try{console.log('[NEX PDP] build r7 - accordion hard-init on load; name memory fixed');}catch(e){}
(function() {
  'use strict';
  window.NEX = window.NEX || {};

  var state = { galleryUnlocked:false, storyRevealed:false, scrollLocked:false, usingFixedFallback:false, currentCategory:null, currentVariantId:null, currentPrice:0, selectedSize:null, panelStep:'type', isOriginal:false };
  var els = {};

  /* ======== KLAVIYO TRACKING HELPERS ========
     Defensive wrappers — silently no-op if klaviyo.js failed to load.
     The Klaviyo onsite tracking script is loaded by the Klaviyo Shopify
     app embed. If the embed is disabled or the script fails for any reason,
     NEX continues working normally — every Klaviyo call becomes a no-op. */
  function nexKlaviyoReady() {
    return typeof window !== 'undefined'
        && window.klaviyo
        && typeof window.klaviyo.push === 'function';
  }
  function nexKlaviyoIdentify(traits) {
    if (!nexKlaviyoReady()) return;
    try { window.klaviyo.push(['identify', traits || {}]); }
    catch (e) { if (window.console) console.warn('NEX: klaviyo identify failed', e); }
  }
  function nexKlaviyoTrack(eventName, properties) {
    if (!nexKlaviyoReady()) return;
    try { window.klaviyo.push(['track', eventName, properties || {}]); }
    catch (e) { if (window.console) console.warn('NEX: klaviyo track failed', e); }
  }
  function nexProductContext() {
    var brandEl = document.querySelector('.nex-brand');
    var titleEl = document.querySelector('.nex-title');
    return {
      Collection:   brandEl ? brandEl.textContent.trim() : '',
      ProductTitle: titleEl ? titleEl.textContent.trim() : ''
    };
  }

  /* ======== RESERVE & ACQUIRE (Original — bespoke enquiry) ========
     The reservation is a pure lead capture — it never touches /cart or /checkout.
     It POSTs name / email / note to a Make webhook, which fans out (studio alert +
     Klaviyo holding-note) downstream. Until the Make scenario is built, this stays a
     PLACEHOLDER: the UX still advances to "Studio confirms" so the flow is fully
     usable now; wiring Make later is a one-line URL swap, no other code change.

     IMPORTANT: replace NEX_RESERVE_WEBHOOK with the live Make webhook URL.
     URLSearchParams body = application/x-www-form-urlencoded → no CORS preflight. */
  var NEX_RESERVE_WEBHOOK = 'https://hook.us1.make.com/REPLACE_WITH_LIVE_WEBHOOK_ID';
  function nexReserveSubmit(payload, onDone) {
    var isPlaceholder = NEX_RESERVE_WEBHOOK.indexOf('REPLACE_WITH_LIVE') !== -1;
    if (isPlaceholder) {
      if (window.console) console.warn('NEX: reserve webhook is a placeholder — not posting. Payload:', payload);
      if (typeof onDone === 'function') onDone(true);
      return;
    }
    try {
      var body = new URLSearchParams();
      Object.keys(payload).forEach(function(k){ body.append(k, payload[k] == null ? '' : payload[k]); });
      fetch(NEX_RESERVE_WEBHOOK, { method: 'POST', body: body })
        .then(function(){ if (typeof onDone === 'function') onDone(true); })
        .catch(function(){ if (typeof onDone === 'function') onDone(false); });
    } catch (e) {
      if (window.console) console.warn('NEX: reserve submit failed', e);
      if (typeof onDone === 'function') onDone(false);
    }
  }

  /* ======== EXPRESS (Shopify dynamic checkout / wallet) ========
     Triggers the wallet button rendered by {{ form | payment_button }} inside the
     hidden #nexBuyForm. Sets the form's variant id first, then clicks the button so
     Apple/Google/Shop Pay opens for the chosen variant. If the wallet button isn't
     present (e.g. Shopify hasn't injected the dynamic-checkout script on this page),
     it falls back to /checkout — where Shopify still shows the Express wallets at the
     top — so Express can never hard-fail. */
  function nexTriggerExpress(variantId, fallbackHref) {
    var idInput  = document.getElementById('nexBuyFormId');
    var walletBtn = document.querySelector('#nexBuyForm [data-shopify="payment-button"] button, #nexBuyForm [data-shopify="payment-button"] [role="button"], #nexBuyForm .shopify-payment-button__button');
    if (idInput && walletBtn) {
      idInput.value = variantId;
      try { walletBtn.click(); return true; } catch (e) {}
    }
    window.location.href = fallbackHref || '/checkout';
    return false;
  }

  /* ======== VIEWED PAINTING EVENT ========
     Fires once on page load if this is a Due West product page.
     Reads metadata from data attributes on the .nex element (set by Liquid in
     narrative-exhibition-v2.liquid). Powers the "continue the story" email
     flow in Klaviyo: each event tells the flow which painting was just viewed
     and which one comes next, so a single email template can dynamically
     reference the next painting via {{ event.NextPaintingTitle }} etc.

     Silently no-ops on non-Due-West pages (no part number) or if the Klaviyo
     onsite script isn't loaded. Fires only once per page load. */
  function nexFireViewedPainting() {
    var nexEl = document.querySelector('.nex');
    if (!nexEl) return;
    var partStr = nexEl.getAttribute('data-due-west-part');
    var part    = parseInt(partStr, 10);
    if (!part || part < 1) return; // not a Due West product — skip silently
    var total        = parseInt(nexEl.getAttribute('data-due-west-total'), 10) || 0;
    var productTitle = nexEl.getAttribute('data-due-west-product-title') || '';
    var productUrl   = nexEl.getAttribute('data-due-west-product-url')   || '';
    var nextTitle    = nexEl.getAttribute('data-next-painting-title')    || '';
    var nextUrl      = nexEl.getAttribute('data-next-painting-url')      || '';
    var isLastPart   = nexEl.getAttribute('data-is-last-part') === 'true';
    nexKlaviyoTrack('Viewed Painting', {
      Collection:        'DUE WEST',
      PartNumber:        part,
      TotalParts:        total,
      ProductTitle:      productTitle,
      ProductURL:        productUrl,
      NextPaintingTitle: nextTitle,
      NextPaintingURL:   nextUrl,
      IsLastPart:        isLastPart
    });
  }

  /* Scroll lock for hero phase */
  /* Scroll lock disabled for debugging */
  (function() {})();

  document.addEventListener('DOMContentLoaded', function() { window.scrollTo(0,0); initAll(); initStickyBar(); });

  /* ======== STICKY BOTTOM CTA BAR ======== */
  function initStickyBar() {
    var bar    = document.getElementById('nexStickyBar');
    var ctaSec = document.getElementById('nexCtaSection');
    if (!bar || !ctaSec) return;

    var convIsActive = false;

    // IntersectionObserver: show bar when CTA section is NOT intersecting,
    // fade it out the moment it scrolls back into view — including during checkout.
    // Never show while conv is active (ctaSec is display:none so observer fires
    // !isIntersecting, but the bar must stay hidden during the checkout flow).
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting && !convIsActive) {
          bar.classList.add('visible');
        } else {
          bar.classList.remove('visible');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(ctaSec);

    // Wrap startCheckout: hide bar during transition, observer restores it naturally
    var _origStart  = NEX.startCheckout;
    var _origExit   = NEX.convExit;

    NEX.startCheckout = function() {
      convIsActive = true;
      bar.classList.remove('visible');
      _origStart.apply(this, arguments);
    };

    NEX.convExit = function() {
      convIsActive = false;
      // Observer will fire naturally as ctaSec is restored to display:''
      // If ctaSec ends up off-screen (unlikely), observer adds visible correctly
      _origExit.apply(this, arguments);
    };
  }

  function cacheElements() {
    els = {
      grid: document.getElementById('nexGrid'), hero: document.getElementById('nexHero'),
      heroFull: document.getElementById('nexHeroFull'), gallery: document.getElementById('nexGallery'),
      productCol: document.getElementById('nexProductCol'), story: document.getElementById('nexStory'),
      storySection: document.getElementById('nexStorySection'), storyWords: null,
      video: document.getElementById('nexProductVideo'), videoItem: document.getElementById('nexVideoItem'),
      scrubTrack: document.getElementById('nexScrubTrack'), scrubFill: document.getElementById('nexScrubFill'), scrubThumb: document.getElementById('nexScrubThumb'),
      roomSection: document.getElementById('nexRoomSection'), roomSlider: document.getElementById('nexRoomSlider'),
      roomTrack: document.getElementById('nexRoomTrack'), roomTabs: document.querySelectorAll('.nex-room-tab'),

      continueSection: document.getElementById('nexContinueSection'), continueQuote: document.getElementById('nexContinueQuote'),
      continueImage: document.getElementById('nexContinueImage'), continueWords: null,
      panelBackdrop: document.getElementById('nexPanelBackdrop'), panel: document.getElementById('nexPanel'),
      panelBody: document.getElementById('nexPanelBody'), panelSummary: document.getElementById('nexPanelSummary'),
      panelDots: document.getElementById('nexPanelDots'),
      headerGroup: document.getElementById('nexHeaderGroup'), brief: document.getElementById('nexBrief'),
      variantOverview: document.getElementById('nexVariantOverview'), ctaSection: document.getElementById('nexCtaSection'),
    };
  }

  /* ======== STORY WORD WRAP ======== */
  function wrapStoryWords() {
    if (!els.story) { console.log('NEX: wrapStoryWords - no story element'); return; }
    var paragraphs = els.story.querySelectorAll('p');
    console.log('NEX: wrapStoryWords - found '+paragraphs.length+' paragraphs');
    if (!paragraphs.length) { var t=els.story.textContent.trim(); if(!t)return; els.story.innerHTML='<p>'+t+'</p>'; paragraphs=els.story.querySelectorAll('p'); }
    paragraphs.forEach(function(p) {
      if (p.classList.contains('nex-part-label')) return;
      var t=p.textContent.trim(); if(!t)return;
      p.innerHTML=t.split(/\s+/).map(function(w){return '<span class="nex-story-word">'+w+'</span>';}).join(' ');
    });
    els.storyWords = document.querySelectorAll('.nex-story-word');
    console.log('NEX: wrapStoryWords - created '+els.storyWords.length+' word spans');
  }
  function wrapContinueQuoteWords() {
    if (!els.continueQuote) return;
    var h2=els.continueQuote.querySelector('h2'); if(!h2)return;
    var t=h2.textContent.trim(); if(!t)return;
    h2.innerHTML=t.split(/\s+/).map(function(w){return '<span class="nex-continue-word">'+w+'</span>';}).join(' ');
    els.continueWords=document.querySelectorAll('.nex-continue-word');
  }

  /* ======== ART ASPECT RATIO — Text alignment ======== */
  var ASPECT_OFFSETS = { '1x1': 17, '4x3': 6, '3x2': 0, '16x9': 0, '3x4': 25, '4x5': 22, '9x16': 35, '2x3': 20 };
  function applyStoryAlignment() {
    if (!els.storySection) return;
    var ratio = document.querySelector('.nex').getAttribute('data-art-aspect-ratio') || '3x2';
    var offset = ASPECT_OFFSETS[ratio] || 0;
    if (offset > 0 && window.innerWidth >= 1200) {
      els.storySection.style.paddingLeft = offset + '%';
      els.storySection.style.paddingRight = offset + '%';
    }
  }

  /* ======== PAGE LOAD SEQUENCE ======== */
  function initPageLoadSequence() {
    console.log('NEX: initPageLoadSequence, hero=' + !!els.hero + ' heroFull=' + !!els.heroFull);
    if (!els.hero || !els.heroFull) return;
    function start() {
      console.log('NEX: start() called');
      els.hero.classList.add('loaded');
      els.hero.classList.add('brightness-normal');
      if(els.headerGroup) els.headerGroup.classList.add('visible');
      if(els.brief) els.brief.classList.add('visible');
      if(els.variantOverview) els.variantOverview.classList.add('visible');
      if(els.ctaSection) els.ctaSection.classList.add('visible');
      document.documentElement.classList.remove('nex-scroll-locked');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
      // Double RAF ensures layout is fully settled before measuring column position
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          initStickyColumn();
          NEX.centreCtaBtn();
        });
      });
      unlockGallery();
    }
    if (els.heroFull.complete && els.heroFull.naturalHeight > 0) { els.heroFull.classList.add('loaded'); start(); }
    else {
      els.heroFull.addEventListener('load', function() { this.classList.add('loaded'); start(); });
      els.heroFull.addEventListener('error', function() {
        els.hero.classList.add('loaded'); els.hero.classList.add('brightness-normal');
        if(els.headerGroup) els.headerGroup.classList.add('visible');
        if(els.brief) els.brief.classList.add('visible');
        if(els.variantOverview) els.variantOverview.classList.add('visible');
        if(els.ctaSection) els.ctaSection.classList.add('visible');
        document.documentElement.classList.remove('nex-scroll-locked');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            initStickyColumn();
            NEX.centreCtaBtn();
          });
        });
        unlockGallery();
      });
    }
  }



  /* ======== STICKY COLUMN ========
     Three phases:
     1. Fixed at heroRect.top while gallery has room
     2. Converts to position:absolute pinned to gallery bottom when gallery ends
     A placeholder div holds the grid space throughout. */
  function initStickyColumn() {
    if (!els.productCol || !els.gallery || !els.hero) return;
    if (window.innerWidth < 1200) return;

    // Measure where the hero image top is — this is our fixed anchor point
    var heroRect = els.hero.getBoundingClientRect();
    var fixedTop = heroRect.top;

    // Measure column dimensions BEFORE changing anything
    var colRect = els.productCol.getBoundingClientRect();
    var colWidth = colRect.width;
    var colLeftInitial = colRect.left;

    // bug6 fix: derive the right-hand column's left deterministically from the
    // grid's content-right edge, rather than from an inserted placeholder whose
    // grid auto-placement is unreliable and was intermittently landing it in the
    // LEFT track (pinning the whole column over the artwork).
    var gridEl = els.productCol.parentNode;
    var colPadRight = parseFloat(getComputedStyle(gridEl).paddingRight) || 0;
    function nexCorrectLeft() {
      return gridEl.getBoundingClientRect().right - colPadRight - colWidth;
    }

    // Create placeholder to hold space in the grid
    var placeholder = document.createElement('div');
    placeholder.style.cssText = 'width:' + colWidth + 'px;min-height:1px;';
    els.productCol.parentNode.insertBefore(placeholder, els.productCol);

    // Pin product col at hero top
    els.productCol.style.setProperty('position', 'fixed', 'important');
    els.productCol.style.setProperty('top', fixedTop + 'px', 'important');
    els.productCol.style.setProperty('width', colWidth + 'px', 'important');
    els.productCol.style.setProperty('left', nexCorrectLeft() + 'px', 'important');
    els.productCol.style.setProperty('z-index', '2', 'important');
    els.productCol.style.setProperty('max-height', 'calc(100vh - ' + fixedTop + 'px - 20px)', 'important');

    state.usingFixedFallback = true;
    var isPinned = true; // true = fixed, false = absolute (scrolling away)

    function updatePosition() {
      if (!state.usingFixedFallback) return;

      var pRect = placeholder.getBoundingClientRect();

      // During text reveal (scroll locked), column stays fixed at fixedTop
      if (state.scrollLocked) {
        if (!isPinned) {
          els.productCol.style.setProperty('position', 'fixed', 'important');
          els.productCol.style.setProperty('left', nexCorrectLeft() + 'px', 'important');
          isPinned = true;
        }
        els.productCol.style.setProperty('top', fixedTop + 'px', 'important');
        els.productCol.style.setProperty('width', pRect.width + 'px', 'important');
        requestAnimationFrame(updatePosition);
        return;
      }

      // After text reveal: check if gallery has scrolled past
      var gRect = els.gallery.getBoundingClientRect();
      var colHeight = els.productCol.offsetHeight;

      if (gRect.bottom <= fixedTop + colHeight) {
        // Gallery can no longer contain the column at fixedTop.
        // Convert to absolute positioning so it scrolls away with the page.
        if (isPinned) {
          isPinned = false;
          var galleryHeight = els.gallery.offsetHeight;
          var galleryTop = els.gallery.offsetTop;
          var absTop = galleryTop + galleryHeight - colHeight;
          var absLeft = nexCorrectLeft() - gridEl.getBoundingClientRect().left;

          els.productCol.style.setProperty('position', 'absolute', 'important');
          els.productCol.style.setProperty('top', absTop + 'px', 'important');
          els.productCol.style.setProperty('left', absLeft + 'px', 'important');
          els.productCol.style.setProperty('width', pRect.width + 'px', 'important');
        }
      } else {
        // Gallery still has room — keep column fixed at fixedTop
        if (!isPinned) {
          isPinned = true;
          els.productCol.style.setProperty('position', 'fixed', 'important');
        }
        els.productCol.style.setProperty('top', fixedTop + 'px', 'important');
        els.productCol.style.setProperty('left', nexCorrectLeft() + 'px', 'important');
        els.productCol.style.setProperty('width', pRect.width + 'px', 'important');
      }

      requestAnimationFrame(updatePosition);
    }

    requestAnimationFrame(updatePosition);
  }

  /* ======== GALLERY UNLOCK ======== */
  function unlockGallery() {
    if (state.galleryUnlocked) return;
    state.galleryUnlocked = true;

    // Start video playing immediately so it's already in motion when it fades in
    if (els.video) {
      els.video.play().catch(function() {});
    }

    // Progressive scroll-driven fade: bidirectional — fades in on scroll down,
    // fades back out when scrolling up and item leaves the viewport.
    var galleryItems = Array.from(els.gallery.querySelectorAll('.nex-gallery-item:not(.nex-hero-wrap)'));

    function updateGalleryOpacities() {
      var vpHeight = window.innerHeight;

      for (var i = 0; i < galleryItems.length; i++) {
        var item = galleryItems[i];
        var rect = item.getBoundingClientRect();

        // Trigger 20% higher: treat vpHeight*0.80 as the entry threshold
        var triggerY = vpHeight * 0.80;

        // Item is completely below the trigger line
        if (rect.top >= triggerY) {
          item.style.opacity = '0';
          item.classList.remove('nex-item-visible');
          continue;
        }

        // Item is completely above the viewport
        if (rect.bottom <= 0) {
          item.style.opacity = '0';
          item.classList.remove('nex-item-visible');
          continue;
        }

        // Progressive reveal based on how far past the trigger line
        var enterDistance = triggerY - rect.top;
        var revealZone = Math.min(rect.height * 0.6, vpHeight * 0.35);
        var progress = Math.min(1, enterDistance / revealZone);

        item.style.opacity = progress.toFixed(3);
        if (progress >= 1) {
          item.classList.add('nex-item-visible');
        } else {
          item.classList.remove('nex-item-visible');
        }
      }

      requestAnimationFrame(updateGalleryOpacities);
    }

    requestAnimationFrame(updateGalleryOpacities);

    // Room section: also bidirectional progressive fade
    if (els.roomSection) {
      function updateRoomOpacity() {
        var vpHeight = window.innerHeight;
        var rect = els.roomSection.getBoundingClientRect();
        var headStart = vpHeight * 0.5;
        var adjustedTop = rect.top - headStart;

        if (adjustedTop >= vpHeight || rect.bottom <= 0) {
          els.roomSection.style.opacity = '0';
          els.roomSection.classList.remove('nex-room-visible');
        } else {
          var enterDistance = vpHeight - adjustedTop;
          var revealZone = vpHeight * 0.6;
          var progress = Math.min(1, enterDistance / revealZone);
          els.roomSection.style.opacity = progress.toFixed(3);
          if (progress >= 1) {
            els.roomSection.classList.add('nex-room-visible');
          } else {
            els.roomSection.classList.remove('nex-room-visible');
          }
        }

        requestAnimationFrame(updateRoomOpacity);
      }
      requestAnimationFrame(updateRoomOpacity);
    }

    initContinueSection();

    // Story word-by-word scroll highlight
    if (els.storyWords && els.storyWords.length) {
      var storyWords = Array.from(els.storyWords);
      var wordTotal  = storyWords.length;
      var lightColor = { r: 184, g: 186, b: 190 };  // #b8babe
      var darkColor  = { r: 42,  g: 40,  b: 39  };  // #2a2827
      var brandColor = { r: 107, g: 114, b: 128 };  // #6B7280 — matches .nex-brand

      // Part label words — same scroll rhythm, different destination colour
      var partWords = Array.from(document.querySelectorAll('.nex-part-word'));
      var partTotal = partWords.length;

      // Initialise both sets to light
      storyWords.forEach(function(w) {
        w.style.setProperty('color', 'rgb(' + lightColor.r + ',' + lightColor.g + ',' + lightColor.b + ')', 'important');
      });
      partWords.forEach(function(w) {
        w.style.setProperty('color', 'rgb(' + lightColor.r + ',' + lightColor.g + ',' + lightColor.b + ')', 'important');
      });

      function lerpWord(w, light, dark, progress, index, total) {
        var r, g, b;
        var full = Math.floor(progress), part = progress - full;
        if (index < full) {
          r = dark.r;  g = dark.g;  b = dark.b;
        } else if (index === full) {
          r = Math.round(light.r + (dark.r - light.r) * part);
          g = Math.round(light.g + (dark.g - light.g) * part);
          b = Math.round(light.b + (dark.b - light.b) * part);
        } else {
          r = light.r; g = light.g; b = light.b;
        }
        w.style.setProperty('color', 'rgb(' + r + ',' + g + ',' + b + ')', 'important');
      }

      function updateStoryHighlight() {
        if (!els.story) return;
        var vpH  = window.innerHeight;
        var rect = els.story.getBoundingClientRect();
        // Reveal starts when story top hits 60% vh, completes at 25% vh
        var triggerLine = vpH * 0.60;
        var endLine     = vpH * 0.25;
        var progress;
        if (rect.top >= triggerLine)  { progress = 0; }
        else if (rect.top <= endLine) { progress = wordTotal; }
        else { progress = ((triggerLine - rect.top) / (triggerLine - endLine)) * wordTotal; }
        progress = Math.max(0, progress);

        // Story words → dark charcoal
        for (var i = 0; i < wordTotal; i++) {
          lerpWord(storyWords[i], lightColor, darkColor, progress, i, wordTotal);
        }

        // Part words — complete early (first 5% of scroll progress)
        if (partTotal > 0) {
          var partProgress = Math.min(partTotal, (progress / (wordTotal * 0.05)) * partTotal);
          for (var j = 0; j < partTotal; j++) {
            lerpWord(partWords[j], lightColor, brandColor, partProgress, j, partTotal);
          }
        }

        requestAnimationFrame(updateStoryHighlight);
      }

      requestAnimationFrame(updateStoryHighlight);
    }
  }
  function initContinueSection() {
    if(!els.continueSection||!els.continueWords||!els.continueWords.length)return;
    var words=Array.from(els.continueWords),total=words.length;
    var light={r:184,g:186,b:190},dark={r:42,g:40,b:39};
    for(var i=0;i<total;i++)words[i].style.setProperty('color','rgb('+light.r+','+light.g+','+light.b+')','important');
    function upd(){var rect=els.continueQuote.getBoundingClientRect(),vpH=window.innerHeight;var start=vpH*0.75,end=vpH*0.25,range=start-end;if(rect.top>=start)return void requestAnimationFrame(upd);if(rect.top<=end){for(var i=0;i<total;i++)words[i].style.setProperty('color','rgb('+dark.r+','+dark.g+','+dark.b+')','important');if(els.continueImage)els.continueImage.style.opacity='1';return;}
    var prog=Math.min(1,(start-rect.top)/range);var full=Math.floor(prog*total),part=(prog*total)-full;for(var i=0;i<total;i++){var r,g,b;if(i<full){r=dark.r;g=dark.g;b=dark.b;}else if(i===full){r=Math.round(light.r+(dark.r-light.r)*part);g=Math.round(light.g+(dark.g-light.g)*part);b=Math.round(light.b+(dark.b-light.b)*part);}else{r=light.r;g=light.g;b=light.b;}words[i].style.setProperty('color','rgb('+r+','+g+','+b+')','important');}
    if(els.continueImage){if(prog<0.5)els.continueImage.style.opacity='0';else els.continueImage.style.opacity=((prog-0.5)/0.5).toFixed(3);}
    requestAnimationFrame(upd);}requestAnimationFrame(upd);
  }

  /* ======== VIDEO ======== */
  function initVideoAutoplay(){if(!els.video||!els.videoItem)return;
    var hasPlayed=false;
    var o=new IntersectionObserver(function(e){e.forEach(function(en){
      if(en.isIntersecting&&state.galleryUnlocked&&!hasPlayed){
        els.video.play().catch(function(){});hasPlayed=true;
        /* Play only once - remove loop */
        els.video.removeAttribute('loop');
      } else if(!en.isIntersecting&&hasPlayed){
        /* Don't pause - let it finish naturally */
      }
    });},{threshold:0.4});o.observe(els.videoItem);
    /* Also remove the early play call */
  }
  function initVideoScrubber(){if(!els.scrubTrack||!els.video)return;var drag=false,ready=false;function chk(){ready=els.video.duration&&isFinite(els.video.duration)&&els.video.duration>0;return ready;}els.video.addEventListener('loadedmetadata',chk);function gp(e){var r=els.scrubTrack.getBoundingClientRect(),cx=e.touches?e.touches[0].clientX:e.clientX;return Math.max(0,Math.min(1,(cx-r.left)/r.width));}function sk(e){if(!chk())return;var p=gp(e);els.video.currentTime=p*els.video.duration;els.scrubFill.style.width=(p*100)+'%';els.scrubThumb.style.left=(p*100)+'%';}function lp(){if(els.video&&!drag&&chk()){var p=(els.video.currentTime/els.video.duration)*100;els.scrubFill.style.width=p+'%';els.scrubThumb.style.left=p+'%';}requestAnimationFrame(lp);}els.scrubTrack.addEventListener('mousedown',function(e){drag=true;sk(e);});els.scrubTrack.addEventListener('touchstart',function(e){drag=true;sk(e);},{passive:true});document.addEventListener('mousemove',function(e){if(drag)sk(e);});document.addEventListener('touchmove',function(e){if(drag)sk(e);},{passive:true});document.addEventListener('mouseup',function(){drag=false;});document.addEventListener('touchend',function(){drag=false;});lp();}

  /* ======== ROOM SLIDER ======== */
  function initRoomSlider(){if(!els.roomSlider||!els.roomTrack)return;var cur=0,total=els.roomTrack.children.length,isDrag=false,startX=0,curT=0,prevT=0;function go(idx){if(idx<0)idx=0;if(idx>=total)idx=total-1;cur=idx;curT=-idx*100;prevT=curT;els.roomTrack.style.transform='translateX('+curT+'%)';els.roomTabs.forEach(function(t){t.classList.toggle('active',parseInt(t.getAttribute('data-room-index'))===idx);});var pb=document.getElementById('nexRoomPrev'),nb=document.getElementById('nexRoomNext');if(pb)pb.classList.toggle('nex-arrow-disabled',idx===0);if(nb)nb.classList.toggle('nex-arrow-disabled',idx>=total-1);var dots=document.querySelectorAll('.nex-room-dot');dots.forEach(function(d){d.classList.toggle('active',parseInt(d.getAttribute('data-room-index'))===idx);});}go(0);els.roomTabs.forEach(function(t){t.addEventListener('click',function(){go(parseInt(this.getAttribute('data-room-index')));});});NEX.roomPrev=function(){go(cur-1);};NEX.roomNext=function(){go(cur+1);};NEX.roomGoTo=function(i){go(i);};
  /* Mouse drag */
  els.roomSlider.addEventListener('mousedown',function(e){isDrag=true;startX=e.clientX;els.roomTrack.classList.add('dragging');});document.addEventListener('mousemove',function(e){if(!isDrag)return;var d=e.clientX-startX,p=(d/els.roomSlider.offsetWidth)*100;els.roomTrack.style.transform='translateX('+(prevT+p)+'%)';});document.addEventListener('mouseup',function(e){if(!isDrag)return;isDrag=false;els.roomTrack.classList.remove('dragging');var d=e.clientX-startX,th=els.roomSlider.offsetWidth*0.15;if(d<-th)go(cur+1);else if(d>th)go(cur-1);else go(cur);});
  /* Touch swipe */
  els.roomSlider.addEventListener('touchstart',function(e){isDrag=true;startX=e.touches[0].clientX;els.roomTrack.classList.add('dragging');},{passive:true});els.roomSlider.addEventListener('touchmove',function(e){if(!isDrag)return;var d=e.touches[0].clientX-startX,p=(d/els.roomSlider.offsetWidth)*100;els.roomTrack.style.transform='translateX('+(prevT+p)+'%)';},{passive:true});els.roomSlider.addEventListener('touchend',function(e){if(!isDrag)return;isDrag=false;els.roomTrack.classList.remove('dragging');var d=(e.changedTouches[0]||e.touches[0]).clientX-startX,th=els.roomSlider.offsetWidth*0.15;if(d<-th)go(cur+1);else if(d>th)go(cur-1);else go(cur);});
  }

  /* ======== ACCORDIONS ======== */
  function initAccordions(){document.querySelectorAll('.nex-accordion-header').forEach(function(h){h.addEventListener('click',function(){var exp=this.getAttribute('aria-expanded')==='true';this.setAttribute('aria-expanded',exp?'false':'true');});});}




  /* ======== VARIANT METAFIELDS ======== */
  var variantMeta={};try{var me=document.getElementById('nexVariantMeta');if(me)variantMeta=JSON.parse(me.textContent);}catch(e){}
  function updateAccordionContent(vid){if(!vid)return;var m=variantMeta[vid];if(!m)return;
    ['nexPanelAdditionalDetails','nexMobileAdditionalDetails'].forEach(function(id){var el=document.getElementById(id);if(el&&m.additional_details)el.innerHTML=m.additional_details;});
    ['nexPanelShippingReturns','nexMobileShippingReturns','nexDrawerShippingReturns'].forEach(function(id){var el=document.getElementById(id);if(el&&m.shipping_returns)el.innerHTML=m.shipping_returns;});
  }

  /* ======== SLIDE-OUT PANEL ======== */
  NEX.openPanel=function(){
    if(els.panelBackdrop)els.panelBackdrop.classList.add('open');
    if(els.panel)els.panel.classList.add('open');
    document.body.style.overflow='hidden';
    panelGoToStep('type');
    panelClearSummary();
    state.currentCategory=null;state.currentVariantId=null;state.currentPrice=0;state.selectedSize=null;state.panelStep='type';
  };
  NEX.closePanel=function(){
    if(els.panelBackdrop)els.panelBackdrop.classList.remove('open');
    if(els.panel)els.panel.classList.remove('open');
    document.body.style.removeProperty('overflow');
  };

  function panelGoToStep(stepName,direction){
    if(!els.panelBody)return;
    var steps=els.panelBody.querySelectorAll('.nex-panel-step');
    var target=els.panelBody.querySelector('[data-panel-step="'+stepName+'"]');
    if(!target)return;
    var current=els.panelBody.querySelector('.nex-panel-step-active');
    direction=direction||'forward';
    if(current&&current!==target){
      // Fade out current
      current.style.opacity='1';current.style.transition='opacity 0.2s ease';current.style.opacity='0';
      setTimeout(function(){
        steps.forEach(function(s){s.classList.remove('nex-panel-step-active');s.style.cssText='';});
        // Fade in target
        target.style.opacity='0';target.style.transform='translateY('+(direction==='forward'?'12':'-12')+'px)';
        target.classList.add('nex-panel-step-active');
        void target.offsetHeight;
        target.style.transition='opacity 0.3s ease, transform 0.3s ease';target.style.opacity='1';target.style.transform='translateY(0)';
        setTimeout(function(){target.style.cssText='';},350);
      },220);
    } else {
      steps.forEach(function(s){s.classList.remove('nex-panel-step-active');s.style.cssText='';});
      target.classList.add('nex-panel-step-active');
    }
    // Update dots
    var stepIdx={'type':0,'size':1,'payment':2};
    if(els.panelDots){var dots=els.panelDots.querySelectorAll('.nex-panel-dot');dots.forEach(function(d,i){d.classList.toggle('active',i<=stepIdx[stepName]);});}
    state.panelStep=stepName;
  }

  function panelAddSummaryRow(key,left,right,delay){
    if(!els.panelSummary)return;
    var existing=els.panelSummary.querySelector('[data-key="'+key+'"]');
    if(existing){existing.querySelector('.nex-panel-summary-left').textContent=left;existing.querySelector('.nex-panel-summary-right').textContent=right;existing.classList.add('visible');return;}
    var label=els.panelSummary.querySelector('.nex-panel-summary-label');
    if(label&&!label.classList.contains('visible'))label.classList.add('visible');
    var row=document.createElement('div');row.className='nex-panel-summary-row';row.setAttribute('data-key',key);
    row.innerHTML='<span class="nex-panel-summary-left">'+left+'</span><span class="nex-panel-summary-right">'+right+'</span>';
    els.panelSummary.appendChild(row);
    setTimeout(function(){row.classList.add('visible');},delay||50);
  }
  function panelRemoveSummaryRow(key){if(!els.panelSummary)return;var r=els.panelSummary.querySelector('[data-key="'+key+'"]');if(r)r.remove();}
  function panelClearSummary(){if(!els.panelSummary)return;var rows=els.panelSummary.querySelectorAll('.nex-panel-summary-row');rows.forEach(function(r){r.remove();});var label=els.panelSummary.querySelector('.nex-panel-summary-label');if(label)label.classList.remove('visible');}

  NEX.panelSelectType=function(category){
    state.currentCategory=category;state.currentVariantId=null;state.currentPrice=0;state.selectedSize=null;
    var title=els.panelBody.getAttribute('data-product-title')||'';
    var brandEl=document.querySelector('.nex-brand');var coll=brandEl?brandEl.textContent.trim():'';
    panelClearSummary();
    if(category==='limited'){
      var opt=els.panelBody.querySelector('[data-category="limited"]');
      var invEl=opt?opt.querySelector('.nex-edition-count'):null;var invText=invEl?invEl.textContent.trim().toUpperCase():'';
      panelAddSummaryRow('name',title,coll,50);
      panelAddSummaryRow('type','Limited Edition Print',invText,180);
      panelGoToStep('size','forward');
    } else {
      var opt=els.panelBody.querySelector('[data-category="original"]');
      var price=parseInt(opt.getAttribute('data-price'))/100;
      var dims=els.panelBody.getAttribute('data-original-dimensions')||'';
      state.currentVariantId=opt.getAttribute('data-variant-id');state.currentPrice=price;state.isOriginal=true;
      updateAccordionContent(state.currentVariantId);
      updatePanelKlarna(price);
      panelAddSummaryRow('name',title,coll,50);
      panelAddSummaryRow('type','Original Painting','1 OF 1',180);
      panelAddSummaryRow('size',dims,'OIL ON CANVAS',300);
      panelAddSummaryRow('price','$'+price.toLocaleString(),'FREE SHIPPING',420);
      panelGoToStep('payment','forward');
    }

    /* Klaviyo: artwork type selection — panel path */
    nexKlaviyoTrack('Selected Artwork Type',{
      ArtworkType:  category==='original'?'Original Painting':'Limited Edition Print',
      ProductTitle: title,
      Collection:   coll,
      VariantId:    state.currentVariantId||null,
      Price:        state.currentPrice||null,
      CheckoutPath: 'desktop_panel'
    });
  };

  NEX.panelSelectSize=function(el){
    var price=parseInt(el.getAttribute('data-price'))/100;
    state.currentVariantId=el.getAttribute('data-variant-id');state.currentPrice=price;
    state.selectedSize=el.querySelector('.nex-panel-option-left').textContent.trim();state.isOriginal=false;
    updateAccordionContent(state.currentVariantId);
    updatePanelKlarna(price);
    panelAddSummaryRow('size',state.selectedSize,'ARCHIVAL QUALITY PRINT',50);
    panelAddSummaryRow('price','$'+price.toLocaleString(),'FREE SHIPPING',180);
    panelGoToStep('payment','forward');
  };

  NEX.panelBack=function(){
    if(state.panelStep==='payment'){
      if(state.currentCategory==='limited'){panelRemoveSummaryRow('size');panelRemoveSummaryRow('price');panelGoToStep('size','back');}
      else{panelClearSummary();panelGoToStep('type','back');state.currentCategory=null;}
      state.currentVariantId=null;state.currentPrice=0;
    } else if(state.panelStep==='size'){
      panelClearSummary();panelGoToStep('type','back');state.currentCategory=null;
    }
  };

  function updatePanelKlarna(price){
    var m=Math.round(price/4);
    var kl=document.getElementById('nexPanelKlarna');if(kl)kl.textContent=m.toLocaleString();
  }

  /* ======== CHECKOUT (shared by panel + mobile) ======== */
  NEX.selectPayment=function(method){
    if(!state.currentVariantId)return;
    fetch('/cart/clear.js',{method:'POST'}).then(function(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:state.currentVariantId,quantity:1})});
    }).then(function(r){return r.json();}).then(function(){
      window.location.href='/checkout';
    }).catch(function(err){console.error('Checkout error:',err);alert('There was an error. Please try again.');});
  };

  /* ======== MOBILE CHECKOUT ======== */
  var isMobile=false;
  function detectMobile(){isMobile=window.innerWidth<1200;}
  var mobileEls={};
  function cacheMobileElements(){
    mobileEls={
      drawer:document.getElementById('nexMobileDrawer'),
      drawerBackdrop:document.getElementById('nexMobileDrawerBackdrop'),
      drawerBody:document.getElementById('nexMobileDrawerBody'),
      drawerSummary:document.getElementById('nexDrawerSummary'),
      drawerDots:document.getElementById('nexDrawerDots'),
      bottomBar:document.getElementById('nexMobileBottomBar'),
      stickyHeader:document.getElementById('nexMobileStickyHeader'),
      productInfo:document.getElementById('nexMobileProductInfo'),
      dots:document.querySelectorAll('.nex-room-dot')
    };
  }

  /* ---- Mobile story word-by-word reveal ---- */
  function initMobileStoryReveal(){
    if(!els.story){console.log('NEX: no story element');return;}
    
    // Force re-wrap if no words found (defensive)
    if(!els.storyWords||!els.storyWords.length){
      console.log('NEX: story words not found, attempting re-wrap');
      var paragraphs=els.story.querySelectorAll('p:not(.nex-part-label)');
      paragraphs.forEach(function(p){
        var t=p.textContent.trim();if(!t)return;
        p.innerHTML=t.split(/\s+/).map(function(w){return '<span class="nex-story-word">'+w+'</span>';}).join(' ');
      });
      els.storyWords=document.querySelectorAll('.nex-story-word');
      console.log('NEX: re-wrapped, now have '+els.storyWords.length+' words');
    }
    
    if(!els.storyWords||!els.storyWords.length){console.log('NEX: still no words after re-wrap');return;}
    
    var words=Array.from(els.storyWords);
    var wordTotal=words.length;
    var lightColor={r:184,g:186,b:190};
    var darkColor={r:42,g:40,b:39};
    var brandColor={r:107,g:114,b:128};
    console.log('NEX: mobile story reveal active with '+wordTotal+' words');

    // Also find PART label words
    var partWords=els.story.querySelectorAll('.nex-part-word');
    partWords=partWords?Array.from(partWords):[];
    var partTotal=partWords.length;

    // Set initial light colour
    for(var i=0;i<wordTotal;i++){
      words[i].style.setProperty('color','rgb('+lightColor.r+','+lightColor.g+','+lightColor.b+')','important');
    }
    for(var j=0;j<partTotal;j++){
      partWords[j].style.setProperty('color','rgb('+lightColor.r+','+lightColor.g+','+lightColor.b+')','important');
    }

    function lerpWord(w,from,to,progress,idx,total){
      var t=Math.max(0,Math.min(1,(progress-idx)/(total*0.01+1)));
      var r=Math.round(from.r+(to.r-from.r)*t);
      var g=Math.round(from.g+(to.g-from.g)*t);
      var b=Math.round(from.b+(to.b-from.b)*t);
      w.style.setProperty('color','rgb('+r+','+g+','+b+')','important');
    }

    function update(){
      if(!els.story)return;
      var vpH=window.innerHeight;
      var rect=els.story.getBoundingClientRect();
      var triggerLine=vpH*0.50;
      var endLine=vpH*0.05;
      var progress;
      if(rect.top>=triggerLine){progress=0;}
      else if(rect.top<=endLine){progress=wordTotal;}
      else{progress=((triggerLine-rect.top)/(triggerLine-endLine))*wordTotal;}
      progress=Math.max(0,progress);

      for(var i=0;i<wordTotal;i++){lerpWord(words[i],lightColor,darkColor,progress,i,wordTotal);}
      if(partTotal>0){
        var partProgress=Math.min(partTotal,(progress/(wordTotal*0.05))*partTotal);
        for(var j=0;j<partTotal;j++){lerpWord(partWords[j],lightColor,brandColor,partProgress,j,partTotal);}
      }
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  /* ---- Mobile gallery progressive fade ---- */
  function initMobileGalleryFades(){
    if(!els.gallery)return;
    // Only fade gallery items INSIDE the gallery, not the room section
    var items=Array.from(els.gallery.querySelectorAll('.nex-gallery-item:not(.nex-hero-wrap)'));
    if(!items.length)return;

    function update(){
      var vpH=window.innerHeight;
      for(var i=0;i<items.length;i++){
        var item=items[i];
        var rect=item.getBoundingClientRect();
        var triggerY=vpH*0.85;
        if(rect.top>=triggerY){item.style.opacity='0';item.classList.remove('nex-item-visible');continue;}
        if(rect.bottom<=0){item.style.opacity='0';item.classList.remove('nex-item-visible');continue;}
        var enterDistance=triggerY-rect.top;
        var revealZone=Math.min(rect.height*0.5,vpH*0.3);
        var progress=Math.min(1,enterDistance/revealZone);
        item.style.opacity=progress.toFixed(3);
        if(progress>=1)item.classList.add('nex-item-visible');
        else item.classList.remove('nex-item-visible');
      }
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  /* ---- Mobile video autoplay on scroll ---- */
  function initMobileVideoAutoplay(){
    if(!els.video||!els.videoItem)return;
    var hasPlayed=false;
    var o=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting&&!hasPlayed){
          els.video.play().catch(function(){});
          hasPlayed=true;
        }
      });
    },{threshold:0.3});
    o.observe(els.videoItem);
  }

  /* ---- Mobile bottom bar — hide when drawer is open ---- */
  function initMobileBottomBar(){
    /* Bottom bar is always visible on mobile unless drawer is open */
  }

  /* ======== MOBILE FULL-SCREEN CONVERSATIONAL DRAWER ======== */
  var dConv = {
    steps: ['name','type','reserve','size','pay','confirmed'],
    current: 0,
    data: { category:'', variantId:null, price:0, dims:'', purchaseNow:false, name:'', lastName:'', email:'', note:'' },
    transitioning: false
  };

  NEX.openMobileDrawer=function(){
    if(!mobileEls.drawer||!mobileEls.drawerBackdrop)return;
    // Reset
    dConv.current=0;
    dConv.data={name:'',lastName:'',email:'',category:'',variantId:null,price:0,dims:''};
    dConv.transitioning=false;
    // Clear receipt
    var rows=document.getElementById('nexDrawerReceiptRows');
    if(rows)rows.innerHTML='';
    var receipt=document.getElementById('nexDrawerReceipt');
    if(receipt)receipt.classList.remove('nex-receipt-visible');
    // Clear reserve inputs (the only capture point in the new flow)
    var rn=document.getElementById('nexDrawerConvReserveName');if(rn)rn.value='';
    var re=document.getElementById('nexDrawerConvReserveEmail');if(re)re.value='';
    var rnote=document.getElementById('nexDrawerConvReserveNote');if(rnote)rnote.value='';
    // Pop-over tie-in: prefill + skip the name step if a first name is already known site-wide.
    var dTtName=(window.TT&&typeof window.TT.getFirstName==='function')?window.TT.getFirstName():'';
    var dNameInp=document.getElementById('nexDrawerConvName');
    var dEntry='name';
    if(dTtName){dConv.data.name=dTtName;if(dNameInp)dNameInp.value=dTtName;dEntry='type';}
    else{if(dNameInp)dNameInp.value='';}
    dConv.current=dConv.steps.indexOf(dEntry);
    drawerConvUpdateLabel();
    // Reset steps — set inline styles since all steps are always absolute
    document.querySelectorAll('.nex-drawer-conv-step').forEach(function(s){
      s.classList.remove('nex-drawer-conv-step-active');
      s.style.transition='none';
      s.style.opacity='0';
      s.style.transform='translateY(20px)';
      s.style.pointerEvents='none';
    });
    var typeQ0=document.getElementById('nexDrawerConvTypeQ');
    if(typeQ0){var gnDraw=(dConv.data.name||'').trim().split(/\s+/)[0];typeQ0.textContent=(dEntry==='type'&&gnDraw)?(gnDraw+', which would you like?'):'Which would you like?';}
    var first=document.querySelector('.nex-drawer-conv-step[data-drawer-conv-step="'+dEntry+'"]');
    if(first){
      first.classList.add('nex-drawer-conv-step-active');
      first.style.opacity='1';
      first.style.transform='translateY(0)';
      first.style.pointerEvents='auto';
    }
    drawerConvUpdateNav();
    // Scroll lock — position:fixed pattern for mobile Safari
    var scrollY=window.scrollY||window.pageYOffset;
    document.body.style.position='fixed';
    document.body.style.top='-'+scrollY+'px';
    document.body.style.left='0';
    document.body.style.right='0';
    document.body.style.overflow='hidden';
    document.body.setAttribute('data-drawer-scroll-y',scrollY);
    // Chrome viewport fix — use visualViewport for accurate height
    drawerConvFixViewportHeight();
    // Open
    mobileEls.drawerBackdrop.classList.add('open');
    mobileEls.drawer.classList.add('open');
    if(mobileEls.bottomBar)mobileEls.bottomBar.classList.add('nex-bar-hidden');
    // Set initial stage height (type step is first; no autofocus on a selection step)
    setTimeout(function(){
      var body=document.getElementById('nexMobileDrawerBody');
      if(body)body.scrollTop=0;
      if(first)drawerConvSetStageHeight(first,false);
    },500);
    // Accordion listeners
    mobileEls.drawer.querySelectorAll('.nex-conv-acc-header').forEach(function(h){
      nexConvAccInit(h);
      h.removeEventListener('click',drawerAccordionHandler);
      h.addEventListener('click',drawerAccordionHandler);
    });
    // Enter key on reserve inputs → submit reservation
    ['nexDrawerConvReserveName','nexDrawerConvReserveEmail'].forEach(function(id){
      var el=document.getElementById(id);
      if(el){el.removeEventListener('keydown',drawerEnterHandler);el.addEventListener('keydown',drawerEnterHandler);}
    });
  };

  function drawerEnterHandler(e){if(e.key==='Enter'){e.preventDefault();NEX.drawerConvReserveSubmit();}}
  function nexConvAccToggle(){
    var exp=this.getAttribute('aria-expanded')==='true';
    this.setAttribute('aria-expanded',exp?'false':'true');
    var body=this.nextElementSibling;
    if(!body)return;
    if(exp){ body.style.setProperty('max-height','0','important'); }
    else { body.style.setProperty('max-height',(body.scrollHeight+40)+'px','important'); }
  }
  function nexConvAccInit(header){
    if(!header)return;
    header.setAttribute('aria-expanded','false');
    var body=header.nextElementSibling;
    if(!body)return;
    body.style.setProperty('max-height','0','important');
    body.style.setProperty('overflow','hidden','important');
    body.style.setProperty('padding','0','important');
    body.style.setProperty('transition','max-height 0.35s ease','important');
    var p=body.querySelector('p');
    if(p){p.style.setProperty('font-family',"'HK Grotesk',sans-serif",'important');p.style.setProperty('font-size','8.5pt','important');p.style.setProperty('line-height','1.6','important');p.style.setProperty('color','#6b7280','important');p.style.setProperty('margin','0','important');}
  }
  function drawerAccordionHandler(){
    nexConvAccToggle.call(this);
    var active=document.querySelector('.nex-drawer-conv-step-active');
    if(active){ drawerConvSetStageHeight(active,true); setTimeout(function(){ drawerConvSetStageHeight(active,true); },380); }
  }
  function nexHardInitShippingAccordions(){
    ['nexConvShipping'].forEach(function(bid){
      var body=document.getElementById(bid); if(!body)return;
      var header=body.previousElementSibling;
      if(!header||!header.classList||!header.classList.contains('nex-conv-acc-header'))return;
      nexConvAccInit(header);
      header.removeEventListener('click',nexConvAccToggle);
      header.addEventListener('click',nexConvAccToggle);
    });
  }

  NEX.closeMobileDrawer=function(){
    if(!mobileEls.drawer||!mobileEls.drawerBackdrop)return;
    mobileEls.drawerBackdrop.classList.remove('open');
    mobileEls.drawer.classList.remove('open');
    // Clear inline viewport height set by drawerConvFixViewportHeight
    mobileEls.drawer.style.removeProperty('height');
    // Restore scroll position — reverse of position:fixed lock
    var scrollY=parseInt(document.body.getAttribute('data-drawer-scroll-y')||'0',10);
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('overflow');
    window.scrollTo(0,scrollY);
    if(mobileEls.bottomBar)mobileEls.bottomBar.classList.remove('nex-bar-hidden');
    hidePrestigeBlocks();
  };

  /* ---- Chrome viewport height fix ---- */
  /* Chrome mobile's 100dvh can still be wrong with position:fixed.
     Use visualViewport.height (the actual visible area) as inline style. */
  function drawerConvFixViewportHeight() {
    var drawer = document.getElementById('nexMobileDrawer');
    if (!drawer) return;
    var vh;
    if (window.visualViewport && window.visualViewport.height) {
      vh = window.visualViewport.height;
    } else {
      vh = window.innerHeight;
    }
    drawer.style.height = vh + 'px';
    // Also listen for viewport resize (keyboard open/close, toolbar changes)
    if (window.visualViewport) {
      var resizeHandler = function() {
        if (!drawer.classList.contains('open')) {
          window.visualViewport.removeEventListener('resize', resizeHandler);
          return;
        }
        drawer.style.height = window.visualViewport.height + 'px';
      };
      window.visualViewport.removeEventListener('resize', resizeHandler);
      window.visualViewport.addEventListener('resize', resizeHandler);
    }
  }

  /* ---- Drawer receipt helpers ---- */
  function drawerConvUpdateLabel(){
    var el=document.getElementById('nexDrawerReceiptLabel');if(!el)return;
    var full=(dConv.data.name||'').trim();
    el.textContent=full?('FOR '+full.toUpperCase()):'YOUR SELECTION';
  }
  function drawerConvReceiptAdd(left,right,key){
    var rows=document.getElementById('nexDrawerReceiptRows');if(!rows)return;
    var existing=rows.querySelector('[data-receipt-key="'+key+'"]');
    if(existing){existing.querySelector('.nex-conv-receipt-row-left').textContent=left;existing.querySelector('.nex-conv-receipt-row-right').textContent=right;return;}
    var row=document.createElement('div');row.className='nex-conv-receipt-row';row.setAttribute('data-receipt-key',key);
    row.style.opacity='0';row.style.transform='translateY(5px)';
    row.innerHTML='<span class="nex-conv-receipt-row-left">'+left+'</span><span class="nex-conv-receipt-row-right">'+right+'</span>';
    rows.appendChild(row);
    // Stagger based on how many rows already exist
    var delay=(rows.querySelectorAll('.nex-conv-receipt-row').length-1)*120+50;
    setTimeout(function(){
      row.style.transition='opacity 0.35s ease, transform 0.35s ease';
      row.style.opacity='1';row.style.transform='translateY(0)';
      row.classList.add('visible');
    },delay);
  }
  function drawerConvReceiptRemoveFrom(key){
    var rows=document.getElementById('nexDrawerReceiptRows');if(!rows)return;
    var all=Array.from(rows.querySelectorAll('.nex-conv-receipt-row'));var found=false;
    all.forEach(function(r){if(r.getAttribute('data-receipt-key')===key)found=true;if(found)r.remove();});
  }

  /* ---- Measure and set stage height from active step ---- */
  function drawerConvSetStageHeight(stepEl, animate) {
    var stage = document.getElementById('nexDrawerConvStage');
    if (!stage || !stepEl) return;
    var h = stepEl.scrollHeight;
    stage.style.transition = animate
      ? 'min-height 0.32s cubic-bezier(0.4,0,0.2,1)'
      : 'none';
    stage.style.minHeight = h + 'px';
  }

  /* ---- Step transition — crossfade with directional slide ---- */
  function drawerConvGoTo(targetIdx, direction, onComplete) {
    if (dConv.transitioning) return;
    if (targetIdx < 0 || targetIdx >= dConv.steps.length) return;
    var targetStep = dConv.steps[targetIdx];
    // (branch navigation is explicit via drawerConvGoToStep — no implicit skipping)
    var currentEl = document.querySelector('.nex-drawer-conv-step-active');
    var targetEl = document.querySelector('.nex-drawer-conv-step[data-drawer-conv-step="' + targetStep + '"]');
    if (!currentEl || !targetEl || currentEl === targetEl) return;
    dConv.transitioning = true;

    // Pre-set step content BEFORE animation so text never flashes
    if (targetStep === 'type') {
      var tq = document.getElementById('nexDrawerConvTypeQ');
      if (tq) { var n = (dConv.data.name || '').trim().split(/\s+/)[0]; tq.textContent = n ? n + ', which would you like?' : 'Which would you like?'; }
    }

    var DUR = 300;
    var ease = 'cubic-bezier(0.4,0,0.2,1)';
    var slideOut = direction === 'forward' ? '-18px' : '18px';
    var slideIn = direction === 'forward' ? '18px' : '-18px';

    // 1. Measure incoming step height and animate stage
    // Make targetEl briefly measurable (absolute, full width, but invisible)
    targetEl.style.transition = 'none';
    targetEl.style.opacity = '0';
    targetEl.style.transform = 'translateY(' + slideIn + ')';
    targetEl.style.pointerEvents = 'none';
    void targetEl.offsetHeight;
    drawerConvSetStageHeight(targetEl, true);

    // 2. Animate outgoing step OUT (opacity + transform only — GPU)
    currentEl.style.transition = 'opacity ' + DUR + 'ms ' + ease + ', transform ' + DUR + 'ms ' + ease;
    currentEl.style.opacity = '0';
    currentEl.style.transform = 'translateY(' + slideOut + ')';
    currentEl.style.pointerEvents = 'none';

    // 3. Animate incoming step IN after a short stagger (40ms)
    setTimeout(function() {
      targetEl.style.transition = 'opacity ' + DUR + 'ms ' + ease + ', transform ' + DUR + 'ms ' + ease;
      targetEl.style.opacity = '1';
      targetEl.style.transform = 'translateY(0)';
      targetEl.style.pointerEvents = 'auto';
    }, 40);

    // 4. Clean up after animation completes
    setTimeout(function() {
      // Remove classes from old step, add to new — but DON'T touch position
      currentEl.classList.remove('nex-drawer-conv-step-active', 'nex-drawer-step-exiting');
      // Reset outgoing step to its dormant state (targeted, not nuclear)
      currentEl.style.transition = 'none';
      currentEl.style.opacity = '0';
      currentEl.style.transform = 'translateY(20px)';
      currentEl.style.pointerEvents = 'none';

      // Settle incoming step — clear transition so it's snappy going forward
      targetEl.classList.add('nex-drawer-conv-step-active');
      targetEl.style.transition = 'none';
      targetEl.style.opacity = '1';
      targetEl.style.transform = 'translateY(0)';
      targetEl.style.pointerEvents = 'auto';

      dConv.current = targetIdx;
      dConv.transitioning = false;
      drawerConvUpdateNav();

      var body = document.getElementById('nexMobileDrawerBody');
      if (body) body.scrollTop = 0;
      var __dstep = dConv.steps[targetIdx];
      if (__dstep !== 'reserve') {
        var inp = targetEl.querySelector('.nex-conv-input');
        if (inp) setTimeout(function() { inp.focus(); }, 60);
      }
      drawerConvUpdateLabel();

      // Fire onComplete callback AFTER everything is settled
      if (typeof onComplete === 'function') setTimeout(onComplete, 30);
    }, DUR + 80);
  }

  /* ---- Nav state ---- */
  function drawerConvUpdateNav(){
    var step=dConv.steps[dConv.current];
    var prevBtn=document.getElementById('nexDrawerConvPrev');
    var nextBtn=document.getElementById('nexDrawerConvNext');
    if(prevBtn){prevBtn.disabled=false;prevBtn.classList.remove('nex-nav-disabled');prevBtn.style.setProperty('opacity','1','important');}
    if(nextBtn){
      var locked=false;
      if(step==='type')locked=true;     // option buttons auto-advance; arrow inert
      if(step==='choice')locked=true;   // buttons navigate
      if(step==='reserve')locked=true;  // INQUIRE button submits; arrow inert
      if(step==='size')locked=!dConv.data.variantId;
      if(step==='pay')locked=true;      // buttons navigate
      if(step==='confirmed')locked=true;
      nextBtn.disabled=locked;nextBtn.classList.toggle('nex-nav-disabled',locked);
      nextBtn.style.setProperty('opacity',locked?'0.25':'1','important');
    }
  }

  /* ---- Branch-aware step navigation ---- */
  function drawerConvPrefillReserveName(){
    var rn=document.getElementById('nexDrawerConvReserveName');
    var em=document.getElementById('nexDrawerConvReserveEmail');
    var fn=(dConv.data.name||'').trim();
    if(rn&&fn&&!rn.value.trim())rn.value=fn;
    function __dFocusEmail(){try{if(em)em.focus();}catch(e){}}
    setTimeout(__dFocusEmail,480);
    setTimeout(__dFocusEmail,720);
  }
  function drawerConvGoToStep(name,direction,onComplete){
    var idx=dConv.steps.indexOf(name);
    if(idx<0)return;
    drawerConvGoTo(idx,direction||'forward',onComplete);
    if(name==='reserve')drawerConvPrefillReserveName();
    if(name==='name'){var ni=document.getElementById('nexDrawerConvName');if(ni&&dConv.data.name)ni.value=dConv.data.name;}
  }

  /* ---- Original branch: Reserve & acquire vs Purchase now ---- */
  NEX.drawerConvSelectChoice=function(which,btn){
    document.querySelectorAll('.nex-drawer-conv-step[data-drawer-conv-step="choice"] .nex-conv-opt-btn').forEach(function(b){b.classList.remove('nex-selected');});
    if(btn)btn.classList.add('nex-selected');
    if(which==='purchase'){
      dConv.data.purchaseNow=true;   // original variant id/price already set in selectType
      drawerConvUpdateNav();
      setTimeout(function(){drawerConvGoToStep('pay','forward');},300);
    }else{
      dConv.data.purchaseNow=false;
      drawerConvUpdateNav();
      setTimeout(function(){drawerConvGoToStep('reserve','forward');},300);
    }
  };

  NEX.drawerConvPurchaseNow=function(){
    dConv.data.purchaseNow=true;
    drawerConvGoToStep('pay','forward');
  };

  /* ---- Original branch: submit the inquiry (the ONLY capture point) ---- */
  NEX.drawerConvReserveSubmit=function(){
    var nameEl=document.getElementById('nexDrawerConvReserveName');
    var emailEl=document.getElementById('nexDrawerConvReserveEmail');
    var noteEl=document.getElementById('nexDrawerConvReserveNote');
    var email=emailEl?emailEl.value.trim():'';
    if(!email||email.indexOf('@')<1){if(emailEl)emailEl.focus();return;}
    var inqName=nameEl?nameEl.value.trim():'';
    var phoneEl=document.getElementById('nexDrawerConvReservePhone');
    dConv.data.email=email;
    dConv.data.note=noteEl?noteEl.value.trim():'';
    var dgreet=(dConv.data.name||inqName||'').trim().split(/\s+/)[0];
    var dct=document.getElementById('nexDrawerConvConfirmTitle');
    if(dct)dct.textContent=dgreet?('Thank You, '+dgreet+'.'):'Thank You.';
    var ctx=nexProductContext();
    nexReserveSubmit({
      type:'inquiry',
      name:inqName,
      email:dConv.data.email,
      phone:phoneEl?phoneEl.value.trim():'',
      note:dConv.data.note,
      product:ctx.ProductTitle,
      collection:ctx.Collection,
      variant_id:dConv.data.variantId||'',
      price:dConv.data.price||'',
      url:window.location.href
    },function(){drawerConvGoToStep('confirmed','forward');});
  };

  /* ---- Public nav ---- */
  NEX.drawerConvNext=function(){
    var step=dConv.steps[dConv.current];
    if(step==='reserve'){NEX.drawerConvReserveSubmit();return;}
    // type / size / pay advance on selection; forward arrow inert elsewhere
  };
  NEX.drawerConvPrev=function(){
    var step=dConv.steps[dConv.current];
    if(step==='type'){NEX.closeMobileDrawer();return;}
    if(step==='confirmed'){drawerConvGoToStep('reserve','backward');return;}
    if(step==='reserve'){drawerConvGoToStep('type','backward');return;}
    if(step==='size'){drawerConvGoToStep('type','backward');return;}
    if(step==='pay'){drawerConvGoToStep(dConv.data.category==='original'?'reserve':'size','backward');return;}
    NEX.closeMobileDrawer();
  };

  /* ---- Type selection ---- */
  NEX.drawerConvSelectType=function(category,btn){
    dConv.data.category=category;
    dConv.data.purchaseNow=false;
    NEX.convSwapHero(category);
    document.querySelectorAll('#nexMobileDrawerBody .nex-conv-opt-btn').forEach(function(b){b.classList.remove('nex-selected');});
    btn.classList.add('nex-selected');
    drawerConvReceiptRemoveFrom('type');

    var countEl=btn.querySelector('.nex-conv-opt-count');var countText=countEl?countEl.textContent.trim():'';

    // Prepare receipt data but DON'T show it yet
    var receiptData=[];
    if(category==='original'){
      dConv.data.variantId=btn.getAttribute('data-variant-id');
      dConv.data.price=parseInt(btn.getAttribute('data-price'),10)/100;
      dConv.data.dims=btn.getAttribute('data-dims')||'';
      receiptData.push({left:'Original Painting',right:'1 OF 1',key:'type'});
      receiptData.push({left:'Oil on Canvas',right:'Framed',key:'medium'});
      if(dConv.data.dims)receiptData.push({left:dConv.data.dims,right:'100% COTTON DUCK CANVAS',key:'size'});
      receiptData.push({left:'$'+dConv.data.price.toLocaleString(),right:'SHIPPED & FULLY INSURED',key:'price'});
      var kl=document.getElementById('nexDrawerConvKlarnaMo');if(kl)kl.textContent=Math.round(dConv.data.price/4).toLocaleString();
      updateAccordionContent(dConv.data.variantId);
    } else {
      dConv.data.variantId=null;dConv.data.price=0;dConv.data.dims='';
      receiptData.push({left:category==='canvas'?'Framed Canvas Edition':'Limited Edition Print',right:category==='canvas'?'1 OF 10':'1 OF 10',key:'type'});
      drawerShowSizeGroup(category);
    }

    /* Klaviyo: artwork type selection — mobile drawer path */
    var ctx=nexProductContext();
    nexKlaviyoTrack('Selected Artwork Type',{
      ArtworkType:  category==='original'?'Original Painting':'Limited Edition Print',
      ProductTitle: ctx.ProductTitle,
      Collection:   ctx.Collection,
      VariantId:    dConv.data.variantId||null,
      Price:        dConv.data.price||null,
      CheckoutPath: 'mobile_drawer'
    });

    drawerConvUpdateNav();

    // Transition first, THEN build receipt after crossfade settles
    var destStep=category==='original'?'reserve':'size';
    setTimeout(function(){
      drawerConvGoToStep(destStep,'forward',function(){
        // This fires after the step transition is fully complete
        drawerConvUpdateLabel();
        receiptData.forEach(function(item){
          drawerConvReceiptAdd(item.left,item.right,item.key);
        });
        var receipt=document.getElementById('nexDrawerReceipt');
        if(receipt)receipt.classList.add('nex-receipt-visible');
      });
    },180);
  };

  /* ---- Size selection ---- */
  NEX.drawerConvSelectSize=function(btn){
    dConv.data.variantId=btn.getAttribute('data-variant-id');
    dConv.data.price=parseInt(btn.getAttribute('data-price'),10)/100;
    dConv.data.dims=btn.getAttribute('data-dims')||btn.querySelector('.nex-conv-size-left').textContent.trim();
    var kl=document.getElementById('nexDrawerConvKlarnaMo');if(kl)kl.textContent=Math.round(dConv.data.price/4).toLocaleString();
    updateAccordionContent(dConv.data.variantId);

    // Prepare receipt data
    var receiptData=[
      {left:dConv.data.dims,right:dConv.data.category==='canvas'?'100% COTTON CANVAS':'Hahnemühle Archival Paper',key:'size'},
      {left:'$'+dConv.data.price.toLocaleString(),right:'FREE SHIPPING',key:'price'}
    ];

    drawerConvUpdateNav();

    // Transition first, THEN build receipt rows after crossfade settles
    setTimeout(function(){
      drawerConvGoToStep('pay','forward',function(){
        drawerConvReceiptRemoveFrom('size');
        receiptData.forEach(function(item){
          drawerConvReceiptAdd(item.left,item.right,item.key);
        });
      });
    },180);
  };

  /* ---- Payment ---- */
  NEX.drawerConvSelectPayment=function(method){
    if(!dConv.data.variantId)return;
    if(method==='express'){
      // Dynamic checkout button checks out the form's variant directly (cart ignored).
      // Fire SYNCHRONOUSLY so the wallet opens within the user gesture.
      nexTriggerExpress(dConv.data.variantId,'/checkout');
      return;
    }
    // Card → add to cart, then standard Shopify checkout (cards + Klarna live here). No capture from us.
    fetch('/cart/clear.js',{method:'POST'}).then(function(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:dConv.data.variantId,quantity:1})});
    }).then(function(){window.location.href='/checkout';}).catch(function(){window.location.href='/checkout';});
  };

  /* ================================================================
     CONVERSATIONAL CHECKOUT — Typeform-style inline flow
     ================================================================

     LAYOUT CONTRACT:
     On startCheckout(), nex-conv is sized to exactly match the hero
     image height. This means the nav arrows always sit at the hero
     bottom, and the question stage occupies the space below the receipt.

     The question is positioned at a FIXED vertical midpoint within
     the stage via a CSS padding-top that is computed once on init and
     never changes. This is what keeps the user's eye anchor stable.

     Steps: name (skip) → email (skip) → type (req) → size (req, prints only) → payment (req)
  ================================================================ */

  var conv = {
    steps: ['name', 'type', 'reserve', 'size', 'pay', 'confirmed'],
    required: { type: true },
    current: 0,
    data: { category: '', variantId: null, price: 0, dims: '', purchaseNow: false,
            name: '', lastName: '', email: '', note: '' },
    heroCentreInStage: 0,  // hero centre relative to stage top — set once at init
    transitioning: false
  };

  /* ---- Receipt helpers ---- */

  // Updates the "YOUR SELECTION / FOR FIRST LAST" label.
  // Reads live from both conv.data AND the input DOM so it works on re-entry.
  function convUpdateReceiptLabel() {
    var labelEl = document.getElementById('nexConvReceiptLabel');
    if (!labelEl) return;
    var full = (conv.data.name || (document.getElementById('nexConvName') ? document.getElementById('nexConvName').value.trim() : '')).trim();
    labelEl.textContent = full ? ('FOR ' + full.toUpperCase()) : 'YOUR SELECTION';
  }

  function convReceiptAdd(left, right, key) {
    var rows = document.getElementById('nexConvReceiptRows');
    if (!rows) return;
    var existing = rows.querySelector('[data-receipt-key="' + key + '"]');
    if (existing) {
      existing.querySelector('.nex-conv-receipt-row-left').textContent = left;
      existing.querySelector('.nex-conv-receipt-row-right').textContent = right;
      return;
    }
    var row = document.createElement('div');
    row.className = 'nex-conv-receipt-row';
    row.setAttribute('data-receipt-key', key);
    row.innerHTML =
      '<span class="nex-conv-receipt-row-left">' + left + '</span>' +
      '<span class="nex-conv-receipt-row-right">' + right + '</span>';
    rows.appendChild(row);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { row.classList.add('visible'); });
    });
  }

  function convReceiptRemoveFrom(key) {
    var rows = document.getElementById('nexConvReceiptRows');
    if (!rows) return;
    var allRows = Array.from(rows.querySelectorAll('.nex-conv-receipt-row'));
    var found = false;
    allRows.forEach(function(r) {
      if (r.getAttribute('data-receipt-key') === key) found = true;
      if (found) r.remove(); // synchronous — prevents timing bug on re-add
    });
  }

  /* ---- Core transition engine ---- */
  function convGoTo(targetIdx, direction) {
    if (conv.transitioning) return;
    if (targetIdx < 0 || targetIdx >= conv.steps.length) return;

    var currentStep = conv.steps[conv.current];
    var targetStep  = conv.steps[targetIdx];

    // (branch navigation is explicit via convGoToStep — no implicit skipping)

    var stage     = document.getElementById('nexConvStage');
    var currentEl = document.querySelector('.nex-conv-step[data-step="' + currentStep + '"]');
    var targetEl  = document.querySelector('.nex-conv-step[data-step="' + targetStep + '"]');
    if (!currentEl || !targetEl || currentEl === targetEl) return;

    conv.transitioning = true;

    // Pre-set step content BEFORE animation so text never flashes
    if (targetStep === 'type') {
      var typeQ = document.getElementById('nexConvTypeQ');
      if (typeQ) {
        var n = (conv.data.name || '').trim().split(/\s+/)[0];
        typeQ.textContent = n ? n + ', which would you like?' : 'Which would you like?';
      }
    }

    var DUR  = 340;
    var ease = 'cubic-bezier(0.4,0,0.2,1)';
    var outY = direction === 'forward' ? '-26px' : '26px';
    var inY  = direction === 'forward' ?  '26px' : '-26px';

    // Lock stage height
    if (stage) {
      stage.style.setProperty('--nex-stage-h', stage.offsetHeight + 'px');
      stage.classList.add('nex-conv-transitioning');
    }

    // OUTGOING — snap absolute, animate out (preserve existing padding)
    var existingPad = currentEl.style.paddingTop || '0px';
    currentEl.style.position   = 'absolute';
    currentEl.style.width      = '100%';
    currentEl.style.top        = '0';
    currentEl.style.paddingTop = existingPad;
    currentEl.style.opacity    = '1';
    currentEl.style.transform  = 'translateY(0)';
    currentEl.style.pointerEvents = 'none';
    void currentEl.offsetHeight;
    currentEl.style.transition = 'opacity ' + DUR + 'ms ' + ease + ',transform ' + DUR + 'ms ' + ease;
    currentEl.style.opacity    = '0';
    currentEl.style.transform  = 'translateY(' + outY + ')';

    // INCOMING — compute centring for this specific step, then animate in
    targetEl.classList.remove('nex-conv-step-active');
    targetEl.style.position   = 'absolute';
    targetEl.style.width      = '100%';
    targetEl.style.top        = '0';
    targetEl.style.paddingTop = '0';
    targetEl.style.opacity    = '0';
    targetEl.style.transform  = 'translateY(' + inY + ')';
    targetEl.style.pointerEvents = 'none';
    void targetEl.offsetHeight;
    // Measure and apply centred padding before animation starts
    convCentreFirstEl(targetEl);

    setTimeout(function() {
      targetEl.style.transition = 'opacity ' + DUR + 'ms ' + ease + ',transform ' + DUR + 'ms ' + ease;
      targetEl.style.opacity    = '1';
      targetEl.style.transform  = 'translateY(0)';
    }, 50);

    // CLEANUP
    setTimeout(function() {
      currentEl.classList.remove('nex-conv-step-active');
      currentEl.removeAttribute('style');

      targetEl.removeAttribute('style');
      targetEl.classList.add('nex-conv-step-active');

      if (stage) {
        stage.classList.remove('nex-conv-transitioning');
        stage.style.removeProperty('--nex-stage-h');
      }
      convCentreFirstEl(targetEl);

      conv.current = targetIdx;
      // Inquire (reserve) is a tall form: let the column grow to fit it (and
      // scroll if it exceeds the viewport) instead of clamping to the hero
      // height. The extra paddingBottom leaves room for the nav arrows to sit
      // BELOW the form rather than colliding with the INQUIRE button.
      var __cw = document.getElementById('nexConv');
      if (__cw) {
        if (conv.steps[targetIdx] === 'reserve') {
          __cw.style.height = 'auto';
          __cw.style.minHeight = (conv.heroPx || 0) + 'px';
          __cw.style.paddingBottom = '80px';
          if (els.productCol) els.productCol.style.setProperty('overflow-y', 'auto', 'important');
        } else {
          __cw.style.height = (conv.heroPx || __cw.offsetHeight) + 'px';
          __cw.style.minHeight = '';
          __cw.style.paddingBottom = '';
          if (els.productCol) els.productCol.style.removeProperty('overflow-y');
        }
      }
      conv.transitioning = false;
      convUpdateNav();
      convPositionNav();

      var __step = conv.steps[targetIdx];
      if (__step !== 'reserve') {
        var input = targetEl.querySelector('.nex-conv-input');
        if (input) setTimeout(function() { input.focus(); }, 50);
      }
      convUpdateReceiptLabel();
    }, DUR + 110);
  }

  /*
   * convCentreFirstEl(stepEl)
   * Centres the first interactive element in stepEl at the hero vertical midpoint.
   * Recomputes the hero-to-stage offset live (accounts for receipt rows growing).
   * Called after each step becomes active.
   */
  function convCentreFirstEl(stepEl) {
    if (!stepEl) return;
    // The Inquire (reserve) step is a tall form — top-align it instead of
    // vertically centring against a possibly-short hero, which clipped fields.
    if (stepEl.getAttribute && stepEl.getAttribute('data-step') === 'reserve') {
      stepEl.style.paddingTop = '0px';
      return;
    }
    var firstEl = stepEl.querySelector(
      '.nex-conv-input, .nex-conv-opt-btn, .nex-conv-size-btn, .nex-conv-pay-btn, .nex-conv-ok'
    );
    if (!firstEl) return;

    // Use document-relative offsetTop measurements — immune to scroll position.
    // We need: "how far is the hero centre from the stage top, in document space?"
    var heroEl  = document.getElementById('nexHero');
    var stageEl = document.getElementById('nexConvStage');
    var heroCentreInStage;
    if (heroEl && stageEl) {
      // Walk offsetParent chain to get document-relative top for each element
      function docTop(el) {
        var t = 0;
        while (el) { t += el.offsetTop; el = el.offsetParent; }
        return t;
      }
      var heroDocTop   = docTop(heroEl);
      var stageDocTop  = docTop(stageEl);
      heroCentreInStage = (heroDocTop + heroEl.offsetHeight / 2) - stageDocTop;
    } else {
      heroCentreInStage = conv.heroCentreInStage;
    }

    // Zero padding, measure natural offsetTop of firstEl within stepEl
    stepEl.style.paddingTop = '0';
    void stepEl.offsetHeight;
    var elOffsetTop = firstEl.offsetTop;
    var elH         = firstEl.offsetHeight;

    var pad = Math.max(0, heroCentreInStage - elOffsetTop - elH / 2);
    stepEl.style.paddingTop = pad + 'px';
  }

  /* ---- Nav state ---- */
  function convUpdateNav() {
    var stepName  = conv.steps[conv.current];
    var isRequired = !!conv.required[stepName];
    var hasValue   = convStepHasValue(stepName);
    var isFirst    = conv.current === 0;

    var prevBtn = document.getElementById('nexConvPrev');
    var nextBtn = document.getElementById('nexConvNext');

    if (prevBtn) {
      // At step 0, prev exits back to product details (never disabled)
      prevBtn.disabled = false;
      prevBtn.classList.remove('nex-nav-disabled');
      prevBtn.style.setProperty('opacity', '1', 'important');
    }
    if (nextBtn) {
      var locked = !hasValue;
      nextBtn.disabled = locked;
      nextBtn.classList.toggle('nex-nav-disabled', locked);
      nextBtn.style.setProperty('opacity', locked ? '0.25' : '1', 'important');
    }
  }

  function convStepHasValue(stepName) {
    if (stepName === 'type')      return false; // option buttons auto-advance; arrow inert
    if (stepName === 'choice')    return false; // buttons navigate
    if (stepName === 'reserve')   return false; // INQUIRE button submits; arrow inert
    if (stepName === 'size')      return !!conv.data.variantId;
    if (stepName === 'pay')       return false; // buttons navigate
    if (stepName === 'confirmed') return false;
    return true;
  }

  /*
   * centreCtaBtn — sets product-col height to hero height and uses a
   * flex spacer so the "Select Yours" button midpoint sits at hero centre.
   * Called on page load and after convExit.
   */
  NEX.centreCtaBtn = function() {
    var heroEl = document.getElementById('nexHero');
    var ctaSec = document.getElementById('nexCtaSection');
    if (!heroEl || !ctaSec) return;

    // Reset any previous inline adjustment
    ctaSec.style.marginTop = '';
    void ctaSec.offsetHeight;

    // getBoundingClientRect works correctly with position:sticky
    var heroR       = heroEl.getBoundingClientRect();
    var ctaR        = ctaSec.getBoundingClientRect();
    var heroCentreY = heroR.top + heroR.height / 2;
    var ctaMidY     = ctaR.top + ctaR.height / 2;
    // delta: how far CTA midpoint needs to move (positive = needs to move up = less margin)
    var delta       = ctaMidY - heroCentreY;
    // Current CSS margin-top on .nex-cta-section is 28px
    // New margin = 28 - delta (clamp to 0 minimum)
    var newMargin   = Math.max(0, 28 - delta);
    ctaSec.style.marginTop = newMargin + 'px';
  };;;

  /* ---- scrollToCta: sticky bar (desktop) + bottom bar (mobile) "Choose Yours".
     Was referenced by the Liquid but never defined — these buttons were dead.
     Desktop: open the checkout flow (startCheckout handles scroll-to-top).
     Mobile: open the full-screen drawer. ---- */
  NEX.scrollToCta = function() {
    if (typeof isMobile !== 'undefined' && isMobile) {
      if (typeof NEX.openMobileDrawer === 'function') NEX.openMobileDrawer();
      return;
    }
    if (typeof NEX.startCheckout === 'function') NEX.startCheckout();
  };

  /* ---- startCheckout: scroll to hero, then fade in conv ---- */
  NEX.startCheckout = function() {
    var convWrap  = document.getElementById('nexConv');
    var heroWrap  = document.getElementById('nexHeroWrap') || document.getElementById('nexHero');
    var ctaSec    = document.getElementById('nexCtaSection');
    var headerGrp = document.getElementById('nexHeaderGroup');
    var brief     = document.getElementById('nexBrief');
    var varOv     = document.getElementById('nexVariantOverview');
    if (!convWrap) return;

    var toHide    = [ctaSec, headerGrp, brief, varOv].filter(Boolean);
    var heroEl    = document.getElementById('nexHero');
    var alreadyAtTop = (window.scrollY || window.pageYOffset) < 80;

    // ── Shared setup: called once the view is ready (scroll done or not needed)
    function activateConv() {
      // Size conv to match hero
      var heroH = heroEl ? heroEl.offsetHeight : (heroWrap ? heroWrap.offsetHeight : window.innerHeight * 0.7);
      convWrap.style.height = heroH + 'px';
      convWrap.style.minHeight = '';
      convWrap.style.paddingBottom = '';
      conv.heroPx = heroH;

      // Bring conv into layout but keep invisible
      convWrap.style.transition = 'none';
      convWrap.style.opacity    = '0';
      convWrap.style.display    = 'flex';
      convWrap.classList.add('nex-conv-active');
      void convWrap.offsetHeight;

      // Measure centres for convCentreFirstEl
      function docTop(el) { var t=0; while(el){t+=el.offsetTop;el=el.offsetParent;} return t; }
      var receiptEl = document.getElementById('nexConvReceipt');
      if (heroEl && convWrap) {
        var heroCentreInConv = (docTop(heroEl) + heroEl.offsetHeight / 2) - docTop(convWrap);
        var receiptH = receiptEl ? receiptEl.offsetHeight : 0;
        conv.heroCentreInStage = heroCentreInConv - receiptH;
      } else {
        conv.heroCentreInStage = heroH * 0.5;
      }

      if (receiptEl) receiptEl.style.paddingBottom = '20px';            // space after the pricing row
      var __resQ = document.querySelector('.nex-conv-step[data-step="reserve"] .nex-conv-q');
      if (__resQ) __resQ.style.marginBottom = '24px';                   // space after the Inquire heading

      // Add receipt row
      var brandEl = document.querySelector('.nex-brand');
      var titleEl = document.querySelector('.nex-title');
      var coll  = brandEl ? brandEl.textContent.trim() : '';
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (title) convReceiptAdd(title, coll, 'product');

      // Reset conv data
      conv.current = 0;
      var keepName = (conv.data && conv.data.name) ? conv.data.name : '';
      conv.data = { name: keepName, lastName: '', email: '', category: '', variantId: null, price: 0, dims: '' };
      var lastGroup = document.getElementById('nexConvLastNameGroup');
      var lastInp   = document.getElementById('nexConvLastName');
      var firstInp  = document.getElementById('nexConvName');
      if (lastGroup) lastGroup.classList.remove('visible');
      if (lastInp)   lastInp.value = '';
      if (firstInp)  firstInp.value = keepName;
      // Pop-over tie-in: prefill + skip the name step if a first name is already known site-wide.
      var ttName = (window.TT && typeof window.TT.getFirstName === 'function') ? window.TT.getFirstName() : '';
      var entryStep = 'name';
      if (ttName) { conv.data.name = ttName; if (firstInp) firstInp.value = ttName; entryStep = 'type'; }
      conv.current = conv.steps.indexOf(entryStep);
      convUpdateReceiptLabel();
      convUpdateNav();

      // Conv container anchors the absolutely-positioned nav arrows
      convWrap.style.setProperty('position', 'relative', 'important');

      // Activate first step (type) and centre
      var typeQ0 = document.getElementById('nexConvTypeQ');
      if (typeQ0) {
        var gnDesk = (conv.data.name || '').trim().split(/\s+/)[0];
        typeQ0.textContent = (entryStep === 'type' && gnDesk) ? (gnDesk + ', which would you like?') : 'Which would you like?';
      }
      var firstStep = document.querySelector('.nex-conv-step[data-step="' + entryStep + '"]');
      if (firstStep) {
        firstStep.classList.add('nex-conv-step-active');
        requestAnimationFrame(function() { convCentreFirstEl(firstStep); convPositionNav(); });
      }

      // Accordion listeners
      document.querySelectorAll('#nexConv .nex-conv-acc-header').forEach(function(btn) {
        nexConvAccInit(btn);
        btn.removeEventListener('click', nexConvAccToggle);
        btn.addEventListener('click', nexConvAccToggle);
      });

      // Fade conv in, focus input
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          convWrap.style.transition = 'opacity 0.45s ease';
          convWrap.style.opacity    = '1';
          if (firstStep) {
            var inp = firstStep.querySelector('.nex-conv-input');
            if (inp) setTimeout(function() { inp.focus(); }, 350);
          }
        });
      });
    }

    if (alreadyAtTop) {
      /* ══ PATH A: Already at top — hero stays put, only right column changes ══
         Fade out the right-column elements, then swap them for conv.
         No overlay, no scroll, no flash. Clean Typeform-style transition.      */
      var fadeCount = toHide.filter(Boolean).length;
      var fadeDone  = 0;

      toHide.forEach(function(el) {
        el.style.transition = 'opacity 0.3s ease';
        el.style.opacity    = '0';
        setTimeout(function() {
          el.style.setProperty('display', 'none', 'important');
          fadeDone++;
          if (fadeDone === fadeCount) activateConv();
        }, 320);
      });

      // If nothing to hide, activate immediately
      if (fadeCount === 0) activateConv();

    } else {
      /* ══ PATH B: Scrolled down — use overlay curtain to hide scroll jump ══  */
      var overlay = document.getElementById('nexTransitionOverlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'nexTransitionOverlay';
        overlay.style.cssText = [
          'position:fixed','top:0','left:0','right:0','bottom:0',
          'background:#f5f3f0','z-index:9999',
          'opacity:0','pointer-events:none',
          'transition:opacity 0.5s ease'
        ].join(';');
        document.body.appendChild(overlay);
      }

      overlay.style.transition  = 'none';
      overlay.style.opacity     = '0';
      overlay.style.pointerEvents = 'all';
      void overlay.offsetHeight;
      overlay.style.transition  = 'opacity 0.5s ease';
      overlay.style.opacity     = '1';

      setTimeout(function() {
        window.scrollTo(0, 0);
        toHide.forEach(function(el) { el.style.setProperty('display', 'none', 'important'); });

        activateConv();

        // Lift overlay as conv fades in
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            overlay.style.transition = 'opacity 0.6s ease';
            overlay.style.opacity    = '0';
            setTimeout(function() { overlay.style.pointerEvents = 'none'; }, 650);
          });
        });

      }, 500);
    }
  };

  /* ---- Explicit step navigation (branch-aware) ---- */
  function convPrefillReserveName() {
    var rn = document.getElementById('nexConvReserveName');
    var em = document.getElementById('nexConvReserveEmail');
    var fn = (conv.data.name || '').trim();
    if (rn && fn && !rn.value.trim()) rn.value = fn;
    function __focusEmail(){ try { if (em) em.focus(); } catch(e){} }
    setTimeout(__focusEmail, 480);
    setTimeout(__focusEmail, 720);
  }
  function convGoToStep(name, direction) {
    var idx = conv.steps.indexOf(name);
    if (idx < 0) return;
    convGoTo(idx, direction || 'forward');
    if (name === 'reserve') convPrefillReserveName();
    if (name === 'name') { var ni = document.getElementById('nexConvName'); if (ni && conv.data.name) ni.value = conv.data.name; }
  }

  /* ---- Position the nav arrows 200px below the active step's bottom-most
     control, right-aligned to it, clamped to the conv (hero) bottom so they
     never spill into the story section below. ---- */
  function convPositionNav() {
    var nav      = document.getElementById('nexConvNav');
    var active   = document.querySelector('.nex-conv-step.nex-conv-step-active');
    var convWrap = document.getElementById('nexConv');
    if (!nav || !active || !convWrap) return;

    var controls = active.querySelectorAll('button, .nex-conv-input, textarea');
    var anchor = null;
    for (var i = 0; i < controls.length; i++) {
      if (controls[i].offsetParent === null) continue; // skip hidden
      if (!anchor || controls[i].getBoundingClientRect().bottom > anchor.getBoundingClientRect().bottom) {
        anchor = controls[i];
      }
    }
    if (!anchor) anchor = active;

    var wrapRect = convWrap.getBoundingClientRect();
    var aRect    = anchor.getBoundingClientRect();

    // Inquire (reserve) is a tall form — sit the arrows just below its last
    // control instead of the +200 hero-gap used by the short centred steps.
    var __isReserve = active.getAttribute && active.getAttribute('data-step') === 'reserve';
    var top  = (aRect.bottom - wrapRect.top) + (__isReserve ? 28 : 200);
    var maxTop = convWrap.offsetHeight - nav.offsetHeight - 8;
    if (maxTop < 0) maxTop = 0;
    if (top > maxTop) top = maxTop;
    if (top < 0) top = 0;

    var right = 0;

    nav.style.setProperty('position', 'absolute', 'important');
    nav.style.setProperty('top',    top + 'px', 'important');
    nav.style.setProperty('right',  right + 'px', 'important');
    nav.style.setProperty('left',   'auto', 'important');
    nav.style.setProperty('bottom', 'auto', 'important');
  }

  /* ---- Original branch: Reserve & acquire  vs  Purchase now ---- */
  NEX.convSelectChoice = function(which, btn) {
    document.querySelectorAll('.nex-conv-step[data-step="choice"] .nex-conv-opt-btn').forEach(function(b){ b.classList.remove('nex-selected'); });
    if (btn) btn.classList.add('nex-selected');
    if (which === 'purchase') {
      conv.data.purchaseNow = true;   // original variant id/price already set in convSelectType
      convUpdateNav();
      setTimeout(function(){ convGoToStep('pay', 'forward'); }, 320);
    } else {
      conv.data.purchaseNow = false;
      convUpdateNav();
      setTimeout(function(){ convGoToStep('reserve', 'forward'); }, 320);
    }
  };

  /* ---- "Or, Purchase Now" link on the Inquire step ---- */
  NEX.convPurchaseNow = function() {
    conv.data.purchaseNow = true;   // original variant id/price already set in convSelectType
    convGoToStep('pay', 'forward');
  };

  /* ---- Original branch: submit the inquiry (the ONLY capture point) ---- */
  NEX.convReserveSubmit = function() {
    var nameEl  = document.getElementById('nexConvReserveName');
    var emailEl = document.getElementById('nexConvReserveEmail');
    var noteEl  = document.getElementById('nexConvReserveNote');
    var email = emailEl ? emailEl.value.trim() : '';
    if (!email || email.indexOf('@') < 1) { if (emailEl) emailEl.focus(); return; }
    var inqName = nameEl ? nameEl.value.trim() : '';
    var phoneEl = document.getElementById('nexConvReservePhone');
    conv.data.email = email;
    conv.data.note  = noteEl ? noteEl.value.trim() : '';
    var greet = (conv.data.name || inqName || '').trim().split(/\s+/)[0];
    var ct = document.getElementById('nexConvConfirmTitle');
    if (ct) ct.textContent = greet ? ('Thank You, ' + greet + '.') : 'Thank You.';
    var ctx = nexProductContext();
    nexReserveSubmit({
      type: 'inquiry',
      name: inqName,
      email: conv.data.email,
      phone: phoneEl ? phoneEl.value.trim() : '',
      note: conv.data.note,
      product: ctx.ProductTitle,
      collection: ctx.Collection,
      variant_id: conv.data.variantId || '',
      price: conv.data.price || '',
      url: window.location.href
    }, function(){ convGoToStep('confirmed', 'forward'); });
  };

  /* ---- Navigation ---- */
  NEX.convNext = function() {
    var stepName = conv.steps[conv.current];
    if (stepName === 'reserve') { NEX.convReserveSubmit(); return; }
    // type / size / pay advance on selection; the forward arrow is inert elsewhere
  };

  NEX.convPrev = function() {
    var stepName = conv.steps[conv.current];
    if (stepName === 'type') { NEX.convExit(); return; }
    if (stepName === 'confirmed') { convGoToStep('reserve', 'backward'); return; }
    if (stepName === 'reserve') { convGoToStep('type', 'backward'); return; }
    if (stepName === 'size')    { convGoToStep('type', 'backward'); return; }
    if (stepName === 'pay')     { convGoToStep(conv.data.category === 'original' ? 'reserve' : 'size', 'backward'); return; }
    NEX.convExit();
  };

  /* ---- Exit conv: fade out, restore product details ---- */
  NEX.convExit = function() {
    var convWrap  = document.getElementById('nexConv');
    var ctaSec    = document.getElementById('nexCtaSection');
    var headerGrp = document.getElementById('nexHeaderGroup');
    var brief     = document.getElementById('nexBrief');
    var varOv     = document.getElementById('nexVariantOverview');
    var spacer    = document.getElementById('nexCtaSpacer');

    // Fade out conv
    if (convWrap) {
      convWrap.style.transition = 'opacity 0.5s ease';
      convWrap.style.opacity = '0';
    }

    setTimeout(function() {
      // Hide conv completely
      if (convWrap) {
        convWrap.style.display = 'none';
        convWrap.classList.remove('nex-conv-active');
        convWrap.style.opacity = '';
        convWrap.style.transition = '';
        // Clear all step state
        document.querySelectorAll('.nex-conv-step').forEach(function(s) {
          s.classList.remove('nex-conv-step-active');
          s.removeAttribute('style');
        });
        // Clear receipt rows
        var rows = document.getElementById('nexConvReceiptRows');
        if (rows) rows.innerHTML = '';
      }

      // Reset conv data
      conv.current = 0;
      var __keepName = (conv.data && conv.data.name) ? conv.data.name : '';
      conv.data = { name: __keepName, lastName: '', email: '', category: '', variantId: null, price: 0, dims: '' };
      // Hide last name group and clear its input
      var lastGroup = document.getElementById('nexConvLastNameGroup');
      var lastInp   = document.getElementById('nexConvLastName');
      if (lastGroup) lastGroup.classList.remove('visible');
      if (lastInp)   lastInp.value = '';
      // Keep first name so it is remembered on re-entry
      var firstInp = document.getElementById('nexConvName');
      if (firstInp) firstInp.value = conv.data.name || '';
      // Label defaults to YOUR SELECTION (both inputs now cleared)
      convUpdateReceiptLabel();
      conv.transitioning = false;

      // Restore product details with fade-in
      var toShow = [ctaSec, headerGrp, brief, varOv].filter(Boolean);
      toShow.forEach(function(el) {
        el.style.removeProperty('display');
        el.style.opacity = '0';
        el.style.transition = 'opacity 0.6s ease';
      });
      void document.body.offsetHeight;
      toShow.forEach(function(el) { el.style.opacity = '1'; });

      // Re-centre the CTA button
      NEX.centreCtaBtn();
      hidePrestigeBlocks();
      NEX.convResetHero();

    }, 500);
  };

  /* ---- First-name step submit (desktop + drawer) ---- */
  NEX.convNameSubmit = function() {
    var inp = document.getElementById('nexConvName');
    conv.data.name = inp ? inp.value.trim() : '';
    convUpdateReceiptLabel();
    convGoToStep('type', 'forward');
  };
  NEX.drawerConvNameSubmit = function() {
    var inp = document.getElementById('nexDrawerConvName');
    dConv.data.name = inp ? inp.value.trim() : '';
    drawerConvUpdateLabel();
    drawerConvGoToStep('type', 'forward');
  };

  /* ---- Hero image swap on type selection (original/canvas -> img 11, print -> img 12) ---- */
  NEX.convSwapHero = function(category) {
    var root = document.querySelector('.nex');
    if (!root) return;
    var u = (category === 'paper') ? root.getAttribute('data-nex-img-print')
          : (category === 'original') ? root.getAttribute('data-nex-img-original')
          : null;
    var img = document.getElementById('nexHeroFull');
    if (img) {
      if (!img.getAttribute('data-nex-default-src')) img.setAttribute('data-nex-default-src', img.getAttribute('src') || '');
      var hu = u || img.getAttribute('data-nex-default-src');
      if (hu) { img.removeAttribute('srcset'); img.src = hu; }
    }
    var thumb = document.querySelector('.nex-mobile-drawer-thumb');
    if (thumb) {
      if (!thumb.getAttribute('data-nex-default-src')) thumb.setAttribute('data-nex-default-src', thumb.getAttribute('src') || '');
      var tu = u || thumb.getAttribute('data-nex-default-src');
      if (tu) { thumb.removeAttribute('srcset'); thumb.src = tu; }
    }
  };
  NEX.convResetHero = function() {
    var img = document.getElementById('nexHeroFull');
    if (img) { var d = img.getAttribute('data-nex-default-src'); if (d) { img.removeAttribute('srcset'); img.src = d; } }
  };

  /* ---- Size-step group visibility (show only the chosen category's sizes) ---- */
  function nexKlarnaMinForGroup(groupSel, elId) {
    var min = null;
    document.querySelectorAll(groupSel + ' .nex-conv-size-btn[data-price]').forEach(function(b) {
      var p = parseInt(b.getAttribute('data-price'), 10);
      if (!isNaN(p) && (min === null || p < min)) min = p;
    });
    if (min !== null) { var el = document.getElementById(elId); if (el) el.textContent = Math.round((min / 100) / 4).toLocaleString(); }
  }
  function convShowSizeGroup(category) {
    document.querySelectorAll('.nex-conv-step[data-step="size"] [data-size-group]').forEach(function(g) {
      if (g.getAttribute('data-size-group') === category) g.style.removeProperty('display');
      else g.style.setProperty('display', 'none', 'important');
    });
    nexKlarnaMinForGroup('.nex-conv-step[data-step="size"] [data-size-group="' + category + '"]', 'nexConvKlarnaMo');
  }
  function drawerShowSizeGroup(category) {
    document.querySelectorAll('.nex-drawer-conv-step[data-drawer-conv-step="size"] [data-size-group]').forEach(function(g) {
      if (g.getAttribute('data-size-group') === category) g.style.removeProperty('display');
      else g.style.setProperty('display', 'none', 'important');
    });
    nexKlarnaMinForGroup('.nex-drawer-conv-step[data-drawer-conv-step="size"] [data-size-group="' + category + '"]', 'nexDrawerConvKlarnaMo');
  }

  /* ---- Type selection ---- */
  NEX.convSelectType = function(category, btn) {
    conv.data.category = category;
    conv.data.purchaseNow = false;
    NEX.convSwapHero(category);
    document.querySelectorAll('.nex-conv-opt-btn').forEach(function(b) { b.classList.remove('nex-selected'); });
    btn.classList.add('nex-selected');
    convReceiptRemoveFrom('type');

    if (category === 'original') {
      conv.data.variantId = btn.getAttribute('data-variant-id');
      conv.data.price     = parseInt(btn.getAttribute('data-price'), 10) / 100;
      conv.data.dims      = btn.getAttribute('data-dims') || '';
      convReceiptAdd('Original Painting', '1 OF 1', 'type');
      convReceiptAdd('Oil on Canvas', 'Framed', 'medium');
      if (conv.data.dims) convReceiptAdd(conv.data.dims, '100% COTTON DUCK CANVAS', 'size');
      convReceiptAdd('$' + conv.data.price.toLocaleString(), 'SHIPPED & FULLY INSURED', 'price');
      var klarnaEl = document.getElementById('nexConvKlarnaMo');
      if (klarnaEl) klarnaEl.textContent = Math.round(conv.data.price / 4).toLocaleString();
    } else {
      conv.data.variantId = null;
      conv.data.price     = 0;
      conv.data.dims      = '';
      convReceiptAdd(category === 'canvas' ? 'Framed Canvas Edition' : 'Limited Edition Print', category === 'canvas' ? '1 OF 10' : '1 OF 10', 'type');
      convShowSizeGroup(category);
    }

    var ctx = nexProductContext();
    nexKlaviyoTrack('Selected Artwork Type', {
      ArtworkType:  category === 'original' ? 'Original Painting' : (category === 'canvas' ? 'Framed Canvas Edition' : 'Limited Edition Print'),
      ProductTitle: ctx.ProductTitle,
      Collection:   ctx.Collection,
      VariantId:    conv.data.variantId || null,
      Price:        conv.data.price     || null,
      CheckoutPath: 'desktop_conv'
    });

    convUpdateNav();
    setTimeout(function() { convGoToStep(category === 'original' ? 'reserve' : 'size', 'forward'); }, 380);
  };

  /* ---- Size selection ---- */
  NEX.convSelectSize = function(btn) {
    conv.data.variantId = btn.getAttribute('data-variant-id');
    conv.data.price     = parseInt(btn.getAttribute('data-price'), 10) / 100;
    conv.data.dims      = btn.getAttribute('data-dims') || btn.querySelector('.nex-conv-size-left').textContent.trim();

    var klarnaEl = document.getElementById('nexConvKlarnaMo');
    if (klarnaEl) klarnaEl.textContent = Math.round(conv.data.price / 4).toLocaleString();

    convReceiptRemoveFrom('size');
    convReceiptAdd(conv.data.dims, conv.data.category === 'canvas' ? '100% COTTON CANVAS' : 'Hahnemühle Archival Paper', 'size');
    convReceiptAdd('$' + conv.data.price.toLocaleString(), 'FREE SHIPPING', 'price');

    convUpdateNav();
    setTimeout(function() { convGoToStep('pay', 'forward'); }, 400);
  };

  /* ---- Payment & checkout ---- */
  NEX.convAddToBag = function() {
    if (!conv.data.variantId) { window.location.href = '/cart'; return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: conv.data.variantId, quantity: 1 }) })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){ window.location.href = '/cart'; });
  };
  NEX.drawerConvAddToBag = function() {
    if (!dConv.data.variantId) { window.location.href = '/cart'; return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: dConv.data.variantId, quantity: 1 }) })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){ window.location.href = '/cart'; });
  };

  NEX.convSelectPayment = function(method) {
    if (!conv.data.variantId) return;
    if (method === 'express') {
      // Dynamic checkout button checks out the form's variant directly (cart is ignored).
      // Fire SYNCHRONOUSLY so the wallet opens within the user gesture — no async first.
      nexTriggerExpress(conv.data.variantId, '/checkout');
      return;
    }
    // Card → add to cart, then standard Shopify checkout (cards + Klarna live here). No capture from us.
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: conv.data.variantId, quantity: 1 })
        });
      })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { window.location.href = '/checkout'; });
  };

  /* ---- Enter key on reserve inputs + reposition arrows on resize ---- */
  document.addEventListener('DOMContentLoaded', function() {
    nexHardInitShippingAccordions(); setTimeout(nexHardInitShippingAccordions, 800);
    var nexNameEl = document.getElementById('nexConvName');
    if (nexNameEl) nexNameEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); NEX.convNameSubmit(); } });
    var nexDrawerNameEl = document.getElementById('nexDrawerConvName');
    if (nexDrawerNameEl) nexDrawerNameEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); NEX.drawerConvNameSubmit(); } });
    ['nexConvReserveName', 'nexConvReserveEmail', 'nexConvReservePhone'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); NEX.convReserveSubmit(); } });
    });
    window.addEventListener('resize', function() {
      var c = document.getElementById('nexConv');
      if (c && c.classList.contains('nex-conv-active')) convPositionNav();
    });
  });


  /* ======== INIT ======== */
  function hidePrestigeBlocks(){
    // Remove the custom tori-accordions that the theme.liquid script creates
    var toriAcc=document.getElementById('tori-accordions');
    if(toriAcc)toriAcc.remove();
    // Also remove any elements with the tori-accordions class
    document.querySelectorAll('.tori-accordions-wrapper').forEach(function(el){el.remove();});
    // Remove Prestige native blocks
    document.querySelectorAll('.product-block-list__item--collapsible_tab, [data-product-block-type], .product-block-list__item--info, .product-form, .product-block-list__item--description, .product-meta__description, .collapsible-content').forEach(function(el){
      if(!el.closest('.nex')&&!el.closest('.nex-mobile-drawer')){
        el.remove();
      }
    });
  }
  // MutationObserver: continuously remove blocks that get re-inserted
  function watchPrestigeBlocks(){
    var target=document.querySelector('.shopify-section--custom-liquid')||document.querySelector('.shopify-section--main-product')||document.body;
    new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType===1){
            // Catch the tori-accordions wrapper
            if(node.id==='tori-accordions'||node.classList&&node.classList.contains('tori-accordions-wrapper')){node.remove();return;}
            if(node.matches&&(node.matches('[data-product-block-type]')||node.matches('.product-block-list__item--collapsible_tab')||node.matches('.collapsible-content')||node.matches('.product-form'))){
              if(!node.closest('.nex')&&!node.closest('.nex-mobile-drawer'))node.remove();
            }
            if(node.querySelectorAll){
              node.querySelectorAll('[data-product-block-type], .product-block-list__item--collapsible_tab, .collapsible-content, .product-form, .product-block-list__item--info, .tori-accordions-wrapper, #tori-accordions').forEach(function(child){
                if(!child.closest('.nex')&&!child.closest('.nex-mobile-drawer'))child.remove();
              });
            }
          }
        });
      });
    }).observe(target,{childList:true,subtree:true});
  }
  function initAll(){
    console.log('NEX: initAll running, innerWidth=' + window.innerWidth);
    cacheElements();wrapStoryWords();wrapContinueQuoteWords();detectMobile();cacheMobileElements();hidePrestigeBlocks();watchPrestigeBlocks();
    nexFireViewedPainting();
    if(isMobile){
      document.documentElement.classList.remove('nex-scroll-locked');
      if(els.hero){els.hero.classList.add('loaded');els.hero.classList.add('brightness-normal');}
      if(els.heroFull)els.heroFull.classList.add('loaded');
      initMobileStoryReveal();initMobileGalleryFades();initMobileVideoAutoplay();
      initContinueSection();initVideoScrubber();initAccordions();initRoomSlider();initMobileBottomBar();
    } else {
      console.log('NEX: desktop path');
      applyStoryAlignment();
      initPageLoadSequence();initVideoAutoplay();initVideoScrubber();initRoomSlider();initAccordions();
    }
  }
})();